module.exports    = {
	"language": "Idioma",
	"hello": "Mundo {{.a}}",
	"c001": "Tempo limite do serviço excedido. Tente novamente mais tarde!",
	"c002": "Sair",
	"c003": "Entrar",
	"c004": "Digite o nome de usuário",
	"c005": "Digite a senha de acesso",
	"c006": "Salvar",
	"c007": "O usuário ou a senha informados estão incorretos",
	"c008": "Usuário",
	"c009": "Idioma",
	"c010": "Total de",
	"c011": "registros",
	"c012": "Olá,",
	"c013": "Sua conta não está ativada. Entre em contato com o administrador.",
	"c014": "Sua conta foi bloqueada. Entre em contato com o administrador.",
	"c015": "Resetar",
	"c016": "Falha na conexão WebSocket",
	"c017": "Erro interno",
	"c018": "Você não tem permissão para realizar esta operação",
	"c019": "O usuário atual não tem permissão para visualizar esta página",
	"c020": "A sessão expirou. Entre novamente!",
	"c021": "Login do usuário",
	"c022": "Documentação",
	"c023": "Aprovado",
	"c024": "Reprovado",
	"c025": "Resultado",
	"c026": "Sistema",
	"c027": "Falha na conexão com o banco de dados. Verifique.",
	"c028": "Falha na inicialização do banco de dados. Verifique.",
	"m001": "Offline",
	"m002": "Online",
	"m003": "Anormal",
	"m004": "Excluído",
	"m005": "Adicionar dispositivo",
	"m006": "Editar dispositivo",
	"m007": "Gerenciamento de dispositivos",
	"m008": "Nº",
	"m009": "Status",
	"m010": "Código do dispositivo",
	"m011": "Nome do dispositivo",
	"m012": "Área",
	"m013": "Ordem",
	"m014": "Endereço IP",
	"m015": "Endereço de comunicação",
	"m016": "Observações",
	"m017": "Data de atualização",
	"m018": "Ação",
	"m019": "Editar",
	"m020": "Dispositivo editado com sucesso",
	"m021": "Dispositivo adicionado com sucesso",
	"m022": "Nome, código ou endereço IP do dispositivo duplicado",
	"m023": "O nome do dispositivo é obrigatório e deve ter pelo menos 2 caracteres",
	"m024": "O código do dispositivo é obrigatório e deve ter pelo menos 2 caracteres",
	"m025": "O endereço IP não pode ficar em branco",
	"m026": "Porta deve ser um número inteiro de até 5 dígitos",
	"m027": "Excluir",
	"m028": "Restaurar",
	"m029": "Porta",
	"m030": "Iniciar conexão automática",
	"m031": "Observação: o endereço de comunicação deve ser igual ao configurado no programador da máquina de solda",
	"m032": "Todas as áreas",
	"m033": "Todos os status",
	"m034": "Selecione",
	"m035": "Online",
	"m036": "Offline",
	"m037": "Erro ao excluir o dispositivo. Tente novamente mais tarde.",
	"m038": "Erro ao restaurar o dispositivo. Tente novamente mais tarde.",
	"m039": "Dispositivo excluído com sucesso",
	"m040": "Dispositivo restaurado com sucesso",
	"m041": "Erro ao obter os dados do dispositivo. Tente novamente mais tarde.",
	"m042": "Formato de endereço IP inválido",
	"m043": "Endereço de comunicação deve ser um número inteiro de até 5 dígitos",
	"m044": "Selecione a área à qual o dispositivo pertence",
	"m045": "Falha ao editar o dispositivo",
	"m046": "Falha ao adicionar o dispositivo",
	"m047": "Nome do dispositivo duplicado. Altere-o.",
	"m048": "Código do dispositivo duplicado. Altere-o.",
	"m049": "Endereço IP duplicado. Altere-o.",
	"m050": "Adquirir curva de corrente",
	"m051": "Adquirir curva de tensão",
	"m052": "Adquirir curva de resistência",
	"m053": "Adquirir curva de pressão",
	"m054": "Conexão automática",
	"m055": "Erro ao interpretar o arquivo importado",
	"m056": "Erro ao ler o arquivo enviado",
	"m057": "Extensão de arquivo inválida (.xlsx; .xlsm; .xltx)",
	"m058": "Arquivo muito grande (limite: 10 MB)",
	"m059": "Dispositivo",
	"m060": "Campo",
	"m061": "Importação concluída: {{.a}} registros importados, dos quais {{.b}} foram adicionados ou alterados",
	"m062": "Falha na importação",
	"m063": "Fechar",
	"m064": "Não é permitido comparar o mesmo programa de soldagem",
	"m065": "Erro ao consultar a lista de controladores",
	"m066": "Extensão de arquivo não permitida",
	"m067": "Senha incorreta. Digite novamente.",
	"m068": "Atualização concluída com sucesso",
	"m069": "Deseja restaurar as configurações de fábrica do controlador?",
	"m070": "Este tipo de dispositivo suporta somente o HRC-803",
	"m071": "O sistema está processando. Aguarde.",
	"m072": "Tarefa adicionada com sucesso e em processamento",
	"m073": "A importação substituirá os dados existentes. Deseja continuar?",
	"m074": "Erro ao gravar o arquivo",
	"m075": "Pesquisar por nome, código, IP, observações ou MAC do dispositivo",
	"m076": "Conectar todos",
	"m077": "Desconectar todos",
	"m078": "Todos os dispositivos foram conectados com sucesso",
	"m079": "Todos os dispositivos foram desconectados com sucesso",
	"m080": "Falha ao conectar todos os dispositivos",
	"m081": "Falha ao desconectar todos os dispositivos",
	"m082": "Não foi possível criar a planilha Excel",
	"m083": "Erro ao desserializar a curva de soldagem",
	"m084": "Erro ao obter os registros de alarmes",
	"m085": "Erro ao gravar os parâmetros do sistema 1",
	"m086": "Erro ao gravar os parâmetros do sistema 2",
	"m087": "Erro ao gravar os parâmetros do sistema 3",
	"m088": "Não encontrado. Primeiro crie a área correspondente.",
	"m089": "Total de dispositivos",
	"m090": "Reconectar",
	"m091": "Backup",
	"m092": "Parâmetros do programa",
	"m093": "Parâmetros do sistema",
	"m094": "Nenhum dispositivo foi selecionado!",
	"m095": "Nenhum parâmetro de backup foi selecionado!",
	"m096": "Backup em lote em andamento. Aguarde.",
	"m097": "O backup não existe!",
	"m098": "Erro ao compactar o backup!",
	"m099": "Backup em lote concluído. Faça o download.",
	"m100": "Falha ao criar o arquivo TAR",
	"m101": "Falha ao obter o caminho",
	"m102": "Backup concluído com sucesso",
	"m103": "Selecione o arquivo de atualização",
	"m104": "Atualização do dispositivo",
	"m105": "Ocorreu um erro durante a atualização",
	"m106": "Os dados do firmware estão vazios; não é possível atualizar",
	"m107": "Não foi possível conectar ao dispositivo “{{.a}}”. Verifique a conexão e, se o problema persistir, reinicie o dispositivo.",
	"m108": "O arquivo não é um pacote de atualização. Verifique.",
	"m109": "Falha ao enviar o pacote inicial",
	"m110": "Resposta anormal ao receber o pacote inicial",
	"m111": "Erro ao enviar o pacote de dados na posição “{{.a}}”",
	"m112": "Erro ao receber o pacote de dados na posição “{{.a}}”",
	"m113": "Erro ao enviar o pacote final",
	"m114": "Erro ao receber o pacote final",
	"m115": "O dispositivo está sendo atualizado. Aguarde.",
	"m116": "Atualizando dispositivo",
	"m117": "Dispositivo atualizado com sucesso",
	"m118": "Falha na atualização do dispositivo",
	"m119": "Tentar novamente",
	"m120": "Aguardando início",
	"m121": "Visão geral do progresso da atualização",
	"m122": "Sucesso:",
	"m123": "Falha",
	"m124": "Em andamento",
	"m125": "Detalhes da atualização do dispositivo",
	"m126": "A página foi atualizada e o arquivo de firmware foi perdido; não é possível tentar novamente.",
	"m127": "Outros",
	"m128": "Atualização cancelada",
	"m129": "Cancelando...",
	"m130": "Ao cancelar, os dispositivos restantes não serão atualizados. Deseja continuar?",
	"m131": "Dispositivos online",
	"m132": "Dispositivos offline",
	"m133": "Reconectar dispositivos",
	"m134": "Nome/código/IP do dispositivo",
	"m135": "Nenhum dispositivo correspondente foi encontrado",
	"m136": "Não há dispositivos disponíveis para operação",
	"m137": "ID do dispositivo",
	"m138": "Versão anterior do software do controlador",
	"m139": "Falha no download: dados correspondentes não encontrados",
	"m140": "Resultado da operação",
	"m141": "Tipo de dispositivo",
	"m142": "Selecione o tipo de dispositivo",
	"m143": "Este tipo de dispositivo não está ativado na sua versão do software. Entre em contato com o fabricante para ativá-lo.",
	"m144": "Máquina de solda MFDC HRC-803",
	"m145": "HRC-802",
	"m146": "HRC-A50",
	"m147": "HRC-501",
	"m148": "Monitor de qualidade de soldagem HRC-650",
	"m149": "Monitor de qualidade de rebitagem HRC-670",
	"m150": "Máquina de solda CA HRC-62",
	"m151": "Código de ativação atual",
	"m152": "Backup de parâmetros",
	"m153": "Restauração de parâmetros",
	"m154": "Importar dispositivos",
	"m155": "Exportar todos os dispositivos",
	"m156": "O backup dos parâmetros do dispositivo está em andamento. Aguarde.",
	"m157": "Backup de parâmetros cancelado",
	"m158": "Não foi possível criar o diretório de backup; falha no backup de parâmetros",
	"m159": "Ocorreu um erro; falha no backup de parâmetros",
	"m160": "Não foi possível ler os dados dos programas; falha no backup de parâmetros",
	"m161": "Não foi possível criar a planilha Excel; falha no backup de parâmetros",
	"m162": "Não foi possível ler os parâmetros do sistema; falha no backup de parâmetros",
	"m163": "O dispositivo está offline; falha no backup de parâmetros",
	"m164": "Visão geral do backup de parâmetros",
	"m165": "Detalhes do backup de parâmetros",
	"m166": "Fazendo backup dos parâmetros do dispositivo",
	"m167": "Backup dos parâmetros concluído com sucesso",
	"m168": "Falha no backup dos parâmetros",
	"m169": "Fazer backup dos parâmetros do programa de soldagem",
	"m170": "Progresso do backup dos parâmetros do programa",
	"m171": "Progresso do backup dos parâmetros do sistema",
	"m172": "Progresso do backup das informações dos pontos de solda",
	"m173": "A nova tentativa de atualização foi iniciada",
	"m174": "A nova tentativa de backup foi iniciada",
	"m175": "O cancelamento da atualização foi iniciado",
	"m176": "O cancelamento do backup foi iniciado",
	"m177": "Ao cancelar, o backup dos dispositivos restantes será interrompido. Deseja continuar?",
	"m178": "Selecione um arquivo compactado TAR",
	"m179": "Erro ao descompactar o arquivo. Verifique se o arquivo está íntegro.",
	"m180": "Restauração de parâmetros concluída",
	"m181": "Ocorreu um erro durante a restauração dos parâmetros",
	"m182": "Visão geral da restauração de parâmetros",
	"m183": "Detalhes da restauração de parâmetros",
	"m184": "Restaurando parâmetros do dispositivo",
	"m185": "Parâmetros restaurados com sucesso",
	"m186": "Falha na restauração dos parâmetros",
	"m187": "Progresso da restauração dos parâmetros do programa",
	"m188": "Progresso da restauração dos parâmetros do sistema",
	"m189": "Progresso da restauração das informações dos pontos de solda",
	"m190": "Erro ao importar as informações dos pontos de solda",
	"m191": "Backup cancelado",
	"m192": "Restauração de parâmetros cancelada",
	"m193": "Há uma tarefa de backup ou restauração em execução no dispositivo; não é possível fazer o download",
	"m194": "Ao cancelar, as restaurações restantes serão interrompidas. Deseja continuar?",
	"m195": "O dispositivo correspondente não foi encontrado no arquivo compactado. Verifique o arquivo.",
	"m196": "A nova tentativa de restauração de parâmetros foi iniciada",
	"m197": "Há outra tarefa em execução no dispositivo; não é possível realizar esta operação",
	"m198": "Parâmetros a restaurar:",
	"m199": "Nenhum tipo de dispositivo está ativado na licença; não é possível adicionar ou editar dispositivos.",
	"m200": "Este dispositivo ainda não suporta esta operação.",
	"m201": "Arquivo de backup",
	"m202": "O arquivo importado não corresponde ao código ou ao tipo do dispositivo. O prefixo do nome deve ser: código do dispositivo + {{.a}}",
	"m203": "Senha de acesso",
	"m204": "Selecione um arquivo",
	"m205": "Os dados não poderão ser recuperados após a limpeza. Deseja continuar?",
	"m206": "Limpar backups",
	"m207": "Limpar",
	"m208": "Limpeza concluída com sucesso",
	"m209": "Falha na limpeza",
	"m210": "Conflito de endereço MAC do dispositivo",
	"m211": "O usuário “{{.a}}” fez backup dos parâmetros do dispositivo “{{.b}}”:",
	"m212": "O dispositivo atual já está aberto; a operação não pode ser repetida",
	"m213": "Endereço MAC",
	"m214": "Ponto de ocorrência do expulsão",
	"m215": "Ajuda",
	"m216": "Desconectar área",
	"m217": "Conectar área",
	"p001": "Criar área",
	"p002": "Editar área",
	"p003": "A área está sendo utilizada e não pode ser excluída",
	"p004": "Gerenciamento de áreas",
	"p005": "Nome da área",
	"p006": "Observações da área",
	"p007": "Área editada com sucesso",
	"p008": "Área adicionada com sucesso",
	"p009": "Nome da área duplicado",
	"p010": "O nome da área é obrigatório e deve ter pelo menos 2 caracteres",
	"p011": "Ordem deve ser um número inteiro positivo de até 5 dígitos",
	"p012": "Parâmetros de paginação inválidos",
	"p013": "Erro ao obter os dados da área. Tente novamente mais tarde.",
	"p014": "O ID de entrada é inválido e deve ser um número inteiro",
	"p015": "Erro ao enviar os dados",
	"p016": "Nome da área duplicado. Altere-o e envie novamente.",
	"p017": "Erro ao adicionar a área. Tente novamente mais tarde.",
	"p018": "Erro ao atualizar a área. Tente novamente mais tarde.",
	"p019": "Erro ao verificar se a área está em uso. Tente novamente mais tarde.",
	"p020": "Erro ao excluir a área. Tente novamente mais tarde.",
	"p021": "Erro ao restaurar a área. Tente novamente mais tarde.",
	"p022": "Área excluída com sucesso",
	"p023": "Área restaurada com sucesso",
	"p024": "registros/página",
	"p025": "Nº do programa antes da fresagem",
	"p026": "Nº do programa após a fresagem",
	"p027": "Sem dados",
	"p028": "Salvar curva de referência",
	"p029": "Este registro não contém dados da curva de resistência",
	"p030": "Consultar curvas de resistência antes/depois da fresagem",
	"p031": "As curvas antes e depois da fresagem têm comprimentos diferentes e não podem ser selecionadas",
	"p032": "Este registro não contém curva de resistência",
	"p033": "O comprimento da curva selecionada é diferente do gráfico atual; não é possível selecioná-la",
	"p034": "Antes da fresagem",
	"p035": "Após a fresagem",
	"p036": "Primeiro selecione um registro de curva",
	"p037": "O registro selecionado não contém dados da curva de resistência",
	"p038": "[Curva de referência] Antes da fresagem",
	"p039": "[Curva de referência] Após a fresagem",
	"p040": "Primeiro gere a curva de referência",
	"p041": "Curva de referência salva com sucesso",
	"p042": "Erro ao consultar os registros de referência das curvas",
	"p043": "Dados da curva inválidos",
	"p044": "A curva está fora da faixa de variação permitida e não pode ser usada para gerar a curva de referência",
	"p045": "O comprimento da curva em tempo real é diferente da curva de referência",
	"p046": "A curva em tempo real após a fresagem está fora da faixa de tolerância",
	"p047": "Configuração de fresagem",
	"p048": "Visualizar configuração de fresagem",
	"p049": "Gerenciar configuração de fresagem",
	"p050": "Monitoramento de fresagem",
	"p051": "Visualizar monitoramento de fresagem",
	"p052": "Gerenciar monitoramento de fresagem",
	"p053": "Faixa de variação para salvar a curva de referência",
	"p054": "Faixa de variação para monitorar a curva de referência",
	"p055": "Tipo de alarme",
	"p056": "Visualizar",
	"p057": "[Curva em tempo real] Antes da fresagem",
	"p058": "[Curva em tempo real] Após a fresagem",
	"p059": "Curva de resistência de referência atual",
	"p060": "Curva de resistência de referência",
	"p061": "Visualizar curva de resistência",
	"p062": "A resistência após a fresagem é maior que antes da fresagem",
	"p063": "As tolerâncias superior e inferior da exclusão automática devem ser maiores que 0",
	"p064": "Tolerâncias superior/inferior para exclusão automática",
	"p065": "Configuração do monitoramento da curva de resistência de soldagem",
	"p066": "Ativar pré-filtro",
	"p067": "A resistência média antes da fresagem menos a resistência média após a fresagem é maior que",
	"p068": "Classificar como normal",
	"p069": "O sistema excluiu automaticamente as curvas fora da faixa de tolerância",
	"p070": "Tolerância superior da curva após a fresagem",
	"p071": "Tolerância inferior da curva após a fresagem",
	"p072": "Informe os números dos programas antes e depois da fresagem",
	"p073": "A diferença de resistência antes e depois da fresagem deve ser maior que 0",
	"p074": "As tolerâncias superior e inferior da curva após a fresagem devem ser maiores que 0",
	"p075": "O pré-filtro está fora da faixa normal",
	"p076": "Versão do software",
	"p077": "Esta versão não suporta esta função",
	"p078": "A calibração de corrente atual usa o padrão do sistema e não pode ser executada",
	"p079": "Etapa",
	"p080": "Limite inferior",
	"p081": "Limite superior",
	"p082": "O número final do programa não pode ser menor que o número inicial",
	"p083": "As faixas dos números de programa são diferentes; não é possível operar",
	"p084": "Sincronizar programas",
	"p085": "diferenças",
	"p086": "Todos iguais",
	"p087": "O dispositivo de origem e o de destino são o mesmo; não é possível sincronizar",
	"p088": "] — sincronizar os parâmetros do programa com o dispositivo de destino:",
	"p089": "Sincronização de parâmetros",
	"p090": "Coeficiente de corrente",
	"p091": "Corrente máxima de saída no secundário",
	"p092": "Ângulo atual do fator de potência",
	"p093": "Ângulo atual de disparo",
	"p094": "Critérios de consulta",
	"p095": "Palavra-chave",
	"p096": "Instante de aquisição",
	"u001": "Gerenciamento de usuários",
	"u002": "Criar usuário",
	"u003": "Nome",
	"u004": "Perfil",
	"u005": "Senha",
	"u006": "Editar usuário",
	"u007": "Visualizador",
	"u008": "Operador",
	"u009": "Administrador",
	"u010": "Não ativado",
	"u011": "Normal",
	"u012": "Bloqueado",
	"u013": "O nome de usuário deve ter pelo menos 3 caracteres",
	"u014": "O nome deve ter pelo menos 3 caracteres",
	"u015": "A senha deve ter pelo menos 3 caracteres",
	"u016": "Selecione o perfil",
	"u017": "Selecione o status",
	"u018": "Usuário editado com sucesso",
	"u019": "Usuário adicionado com sucesso",
	"u020": "Erro ao obter os dados do usuário. Tente novamente mais tarde.",
	"u021": "Usuário excluído com sucesso",
	"u022": "Usuário restaurado com sucesso",
	"u023": "Nome de usuário duplicado. Altere-o.",
	"u024": "Erro ao adicionar o usuário. Tente novamente mais tarde.",
	"u025": "Erro ao editar usuário. Tente novamente mais tarde.",
	"u026": "Erro ao excluir o usuário. Tente novamente mais tarde.",
	"u027": "Erro ao restaurar o usuário. Tente novamente mais tarde.",
	"u028": "ID do operador",
	"u029": "Gerenciamento de perfis",
	"u030": "Criar perfil",
	"u031": "Erro ao obter os dados dos perfis. Tente novamente mais tarde.",
	"u032": "Nome do perfil duplicado. Altere-o.",
	"u033": "Erro ao adicionar o perfil. Tente novamente mais tarde.",
	"u034": "Erro ao editar perfil. Tente novamente mais tarde.",
	"u035": "Erro ao excluir o perfil. Tente novamente mais tarde.",
	"u036": "Erro ao restaurar o perfil. Tente novamente mais tarde.",
	"u037": "Perfil adicionado com sucesso",
	"u038": "Perfil editado com sucesso",
	"u039": "Perfil excluído com sucesso",
	"u040": "Perfil restaurado com sucesso",
	"u041": "Nome do perfil",
	"u042": "Editar perfil",
	"u043": "O nome do perfil é obrigatório e deve ter pelo menos 2 caracteres",
	"u044": "Permissões",
	"u045": "Área",
	"u046": "Visualizar áreas",
	"u047": "Configuração de permissões",
	"u048": "Dispositivo",
	"u049": "Visualizar dispositivos",
	"u050": "Conectar/desconectar dispositivos",
	"u051": "Usuário",
	"u052": "Visualizar usuários",
	"u053": "Visualizar biblioteca de programas",
	"u054": "Gerenciar biblioteca de programas",
	"u055": "Visualizar registros do sistema",
	"u056": "Gerenciar registros do sistema",
	"u057": "Visualizar inicialização do sistema",
	"u058": "Gerenciar inicialização do sistema",
	"u059": "Visualizar monitoramento em tempo real",
	"u060": "Operar monitoramento em tempo real",
	"u061": "Visualizar monitoramento em tempo real",
	"u062": "Operar monitoramento em tempo real",
	"u063": "Visualizar parâmetros do programa",
	"u064": "Operar parâmetros do programa",
	"u065": "Visualizar gerenciamento da produção",
	"u066": "Operar gerenciamento da produção",
	"u067": "Visualizar parâmetros do sistema",
	"u068": "Operar parâmetros do sistema",
	"u069": "Visualizar registros de soldagem",
	"u070": "Operar registros de soldagem",
	"u071": "Visualizar registros de alarmes",
	"u072": "Operar registros de alarmes",
	"u073": "Visualizar histórico de alterações",
	"u074": "Operar histórico de alterações",
	"u075": "Visualizar gerenciamento de pontos de solda",
	"u076": "Operar gerenciamento de pontos de solda",
	"u077": "Visualizar perfis",
	"u078": "Permissões configuradas com sucesso",
	"u079": "Confirmar senha",
	"u080": "As senhas digitadas não coincidem. Digite novamente!",
	"u081": "Sem permissão para obter as informações de registro. Autorize primeiro.",
	"u082": "Informações de registro ausentes. Ative o produto primeiro.",
	"u083": "Informações de registro inválidas. Registre novamente.",
	"u084": "A versão atual é de avaliação. Solicite um código de ativação para usar o software.",
	"u085": "Ativar",
	"u086": "Ativação do produto",
	"u087": "Número de série do produto",
	"u088": "Envie ao fabricante o número de série abaixo ou o QR code à esquerda para obter o código de ativação.",
	"u089": "Digite o código de ativação",
	"u090": "Em caso de dúvidas, entre em contato com o suporte técnico.",
	"u091": "Copiado com sucesso.",
	"u092": "Falha ao copiar.",
	"u093": "Ativar produto",
	"u094": "Visualizar ativação",
	"u095": "Operar ativação",
	"u096": "Erro ao ativar o tipo de dispositivo",
	"u097": "Falha ao gerar o código de ativação",
	"u098": "Código de ativação incorreto",
	"u099": "Digite o código de ativação",
	"u100": "Número de série do produto ausente",
	"u102": "Código de ativação inválido!",
	"u103": "Falha ao gravar as informações de ativação. Tente novamente mais tarde.",
	"u104": "Ativação concluída. Os recursos serão liberados conforme o código de ativação. Em caso de dúvidas, entre em contato com o fabricante.",
	"u105": "Alterar senha",
	"u106": "Senha atual",
	"u107": "Nova senha",
	"u108": "Digite a senha atual",
	"u109": "A senha atual está incorreta",
	"u110": "Digite a nova senha",
	"u111": "Senha alterada com sucesso",
	"u112": "Falha ao alterar a senha",
	"u113": "Colunas exibidas",
	"u114": "Selecione as colunas a exibir",
	"u115": "Selecione pelo menos uma coluna para exibição",
	"l001": "Console",
	"l002": "Online",
	"l003": "Conectar todos",
	"l004": "Desconectar todos",
	"l005": "Alarme",
	"l006": "Desconectado com sucesso",
	"l007": "Conectado com sucesso",
	"l008": "Falha ao desconectar",
	"l009": "Falha ao conectar",
	"l010": "Recolher tudo",
	"l011": "Expandir tudo",
	"b001": "Gerenciamento do banco de dados",
	"b002": "Biblioteca de programas de soldagem",
	"b003": "Cópia de parâmetros do sistema",
	"b004": "Comparação de parâmetros",
	"b005": "Parâmetros de limite de corrente",
	"b006": "Nº do programa",
	"b007": "Nome do programa",
	"b008": "Mín. solda 1",
	"b009": "Máx. solda 1",
	"b010": "Mín. solda 2",
	"b011": "Máx. solda 2",
	"b012": "Mín. solda 3",
	"b013": "Máx. solda 3",
	"b014": "Modo de potência",
	"b015": "Híbrido",
	"b016": "Corrente constante",
	"b017": "Ciclo de trabalho",
	"b018": "Pré-pressão",
	"b019": "Pressão de acompanhamento",
	"b020": "Pré-soldagem",
	"b021": "Resfriamento",
	"b022": "Rampa de subida",
	"b023": "Solda 1",
	"b024": "Resfriamento 1",
	"b025": "Solda 2",
	"b026": "Resfriamento 2",
	"b027": "Solda 3",
	"b028": "Rampa de descida",
	"b029": "Resfriamento",
	"b030": "Pós-soldagem",
	"b031": "Retenção",
	"b032": "Pausa",
	"b033": "Copiar",
	"b034": "Zerar este grupo",
	"b035": "Enviar este grupo de programas",
	"b036": "Enviar programas em lote",
	"b037": "Número de pulsos da solda 2",
	"b038": "Sem dados de configuração",
	"b039": "Erro ao obter o valor máximo do programa",
	"b040": "Programa de soldagem",
	"b041": "Erro ao adicionar o programa. Tente novamente mais tarde.",
	"b042": "Programa adicionado com sucesso",
	"b043": "Erro ao alterar o programa. Tente novamente mais tarde.",
	"b044": "Programa alterado com sucesso",
	"b045": "Erro ao excluir o programa. Tente novamente mais tarde.",
	"b046": "Programa excluído com sucesso",
	"b047": "Número do programa duplicado. Altere-o e envie novamente.",
	"b048": "Erro ao obter o número do programa. Tente novamente mais tarde.",
	"b049": "Nome do programa não pode ficar em branco",
	"b050": "Erro ao copiar o programa. Tente novamente mais tarde.",
	"b051": "Programa copiado com sucesso",
	"b052": "Selecione os programas a excluir",
	"b053": "Selecione os programas a zerar",
	"b054": "Selecione os programas a copiar",
	"b055": "Os dados não poderão ser recuperados após a exclusão. Deseja continuar?",
	"b056": "Selecionar tudo",
	"b057": "Dispositivo de origem",
	"b058": "Dispositivo de destino",
	"b059": "Enviar todos os parâmetros do sistema",
	"b060": "Comparar",
	"b061": "Modo de comparação",
	"b062": "Controlador",
	"b063": "Erro ao consultar dados da biblioteca de programas",
	"b064": "Erro na operação",
	"b065": "Parâmetro",
	"b066": "Corrente mínima da solda 1",
	"b067": "Corrente máxima da solda 1",
	"b068": "Corrente mínima da solda 2",
	"b069": "Corrente máxima da solda 2",
	"b070": "Corrente mínima da solda 3",
	"b071": "Corrente máxima da solda 3",
	"b072": "Tempo de pré-pressão",
	"b073": "Pressão de pré-pressão",
	"b074": "Tempo da pressão de acompanhamento",
	"b075": "Pressão de acompanhamento",
	"b076": "Seleção do controle de pré-soldagem",
	"b077": "Corrente de pré-soldagem",
	"b078": "Tempo de pré-soldagem",
	"b079": "[Reservado] Pressão de pré-soldagem [kN (0–10000) ou % (0–100)]",
	"b080": "Tempo de resfriamento 0",
	"b081": "[Reservado] Pressão de resfriamento 0 (kN ou %)",
	"b082": "Tempo de rampa de subida",
	"b083": "Seleção do controle da solda 1",
	"b084": "Corrente da solda 1",
	"b085": "Tempo da solda 1",
	"b086": "Habilitar função UIP (0–1)",
	"b087": "Tempo de resfriamento 1",
	"b088": "[Reservado] Pressão da solda 1 [kN (0–10000) ou % (0–100)]",
	"b089": "Seleção do controle da solda 2",
	"b090": "Corrente da solda 2",
	"b091": "Tempo da solda 2",
	"b092": "Pressão da solda 2",
	"b093": "Tempo de resfriamento 2",
	"b094": "Valor de referência UIP %",
	"b095": "Número de pulsos da solda 2",
	"b096": "Seleção do controle da solda 3",
	"b097": "Corrente da solda 3",
	"b098": "Tempo da solda 3",
	"b099": "Faixa de tolerância superior do UIP %",
	"b100": "Tempo de rampa de descida",
	"b101": "Tempo de resfriamento 3",
	"b102": "Faixa de tolerância da condição superior do UIP",
	"b103": "Seleção do controle de pós-soldagem",
	"b104": "Corrente de pós-soldagem",
	"b105": "Tempo de pós-soldagem",
	"b106": "Faixa de tolerância da condição inferior do UIP",
	"b107": "Tempo de retenção",
	"b108": "Faixa de tolerância inferior do UIP",
	"b109": "Tempo de pausa",
	"b110": "Pressão de pausa",
	"b111": "Seleção do controle de potência (0–2): 0 = corrente constante; 1 = ciclo de trabalho; 2 = híbrido",
	"b112": "Limite de resistência para detecção de expulsão",
	"b113": "Controlador 1",
	"b114": "Controlador 2",
	"b115": "Biblioteca de programas 1",
	"b116": "Biblioteca de programas 2",
	"b117": "Enviar este grupo de programas",
	"b118": "Enviar programas em lote",
	"b119": "Selecione o nº do dispositivo:",
	"b120": "Enviar para o grupo do controlador nº:",
	"b121": "Grupo",
	"b122": "Controlador",
	"b123": "De",
	"b124": "Até",
	"b125": "Envio concluído com sucesso",
	"b126": "Erro ao obter o tipo de dispositivo",
	"b127": "Número do programa do dispositivo de destino fora da faixa (0–{{.a}})",
	"b128": "O programa nº “{{.a}}” não existe",
	"b129": "Falha no envio",
	"b130": "Erro na seleção da faixa",
	"b131": "As faixas de envio são diferentes ({{.a}}–{{.b}})",
	"b132": "O usuário “{{.a}}” enviou o programa nº “{{.c}}” ao dispositivo {{.b}}",
	"b133": "O usuário “{{.a}}” enviou programas em lote ao dispositivo {{.b}}, de “{{.c}}–{{.d}}” para “{{.e}}–{{.f}}”",
	"b134": "Selecione os dispositivos de origem e de destino",
	"b135": "Confirmar operação",
	"b136": "Deseja sincronizar os parâmetros do sistema do dispositivo [",
	"b137": "Deseja sincronizar os parâmetros do sistema do dispositivo [",
	"b138": "] com o dispositivo de destino?",
	"b139": "Os dados enviados não contêm um código de controlador válido",
	"b140": "O usuário “{{.a}}” copiou os parâmetros do sistema da máquina ID “{{.b}}” para “{{.c}}”",
	"b141": "Os números dos programas são iguais; não é possível comparar",
	"b142": "Nº do programa fora da faixa (0-959)",
	"b143": "Nº do programa fora da faixa (0-63)",
	"b144": "Controlador não encontrado",
	"b145": "[Reservado] Pressão da solda 1 [kN (0–10000) ou % (0–100)]",
	"b146": "[Reservado] Pressão de resfriamento 2 [kN (0–10000) ou % (0–100)]",
	"b147": "[Reservado] Pressão de resfriamento 3 [kN (0–10000) ou % (0–100)]",
	"b148": "[Reservado] Pressão de pós-soldagem [kN (0–10000) ou % (0–100)]",
	"b149": "[Reservado] Pressão de retenção [kN (0–10000) ou % (0–100)]",
	"b150": "Não é permitido comparar o mesmo programa de soldagem",
	"b151": "{{.a}}: entrada inválida",
	"b152": "Erro de validação da entrada",
	"b153": "Sincronizar do dispositivo para a biblioteca offline",
	"b154": "Sincronizar da biblioteca offline para o dispositivo",
	"b155": "Nº",
	"b156": "Sincronizar",
	"b157": "Erro na seleção da faixa",
	"b158": "O usuário “{{.a}}” sincronizou o programa “{{.d}}” do dispositivo “{{.c}}” para a biblioteca offline do dispositivo ID {{.b}}",
	"b159": "Sincronização concluída com sucesso",
	"b160": "Falha na sincronização",
	"b161": "O usuário “{{.a}}” salvou o programa “{{.c}}” na biblioteca offline do dispositivo ID “{{.b}}”",
	"b162": "Salvo com sucesso",
	"b163": "Falha ao salvar",
	"b164": "O usuário “{{.a}}” sincronizou o programa “{{.c}}” da biblioteca offline para o dispositivo ID {{.b}}",
	"b165": "Exportar parâmetros do programa",
	"b166": "Modo de controle da pré-soldagem",
	"b167": "Modo de controle da solda 1",
	"b168": "Modo de controle da solda 2",
	"b169": "Modo de controle da solda 3",
	"b170": "Modo de controle da pós-soldagem",
	"b171": "A importação substituirá os dados existentes. Deseja continuar?",
	"b172": "Este arquivo não pode ser importado para este dispositivo",
	"b173": "O usuário “{{.a}}” importou o programa “{{.c}}” para o dispositivo ID {{.b}}",
	"b174": "O usuário “{{.a}}” importou o programa “{{.c}}” para a biblioteca offline do dispositivo ID {{.b}}",
	"b175": "Importação concluída: {{.a}} registros importados",
	"b176": "Detalhes",
	"b177": "Selecione os registros a excluir",
	"b178": "Falha ao excluir os registros",
	"b179": "Registros excluídos com sucesso",
	"b180": "Deseja excluir os registros selecionados?",
	"b181": "Confirmar",
	"b182": "Cancelar",
	"b183": "Erro ao obter os registros de soldagem. Tente novamente mais tarde.",
	"b184": "Nº do programa em uso",
	"b185": "Etapa de trabalho atual",
	"b186": "Tempo decorrido da etapa atual",
	"b187": "O registro não existe",
	"b188": "Falha na pesquisa: nenhuma curva de soldagem correspondente foi encontrada",
	"b189": "Erro ao obter os registros de alarmes. Tente novamente mais tarde.",
	"b190": "Erro ao obter o histórico de alterações. Tente novamente mais tarde.",
	"b191": "Detalhes do programa",
	"b192": "Clique em 'Enviar' para aplicar a função 'Zerar'!",
	"b193": "Pressão fora da faixa",
	"b194": "Espessura da chapa fora da faixa",
	"b195": "linha",
	"b196": "já existe",
	"b197": "Há outra tarefa em andamento; não é possível processar agora",
	"b198": "Importação do gerenciamento de pontos concluída com sucesso",
	"b199": "Falha na importação do gerenciamento de pontos",
	"b200": "Validação do gerenciamento de pontos concluída com sucesso",
	"b201": "Falha na validação do gerenciamento de pontos",
	"b202": "Limpeza do gerenciamento de pontos concluída com sucesso",
	"b203": "Falha na limpeza do gerenciamento de pontos",
	"b204": "Pressão fora da faixa (0-65535)",
	"b205": "Espessura da chapa fora da faixa (0–655,35)",
	"b206": "Selecione um programa. Se não houver nenhum, crie um novo.",
	"b207": "Importação do gerenciamento de pontos concluída com sucesso",
	"b208": "Falha na importação do gerenciamento de pontos",
	"b209": "Falha ao excluir os dados locais dos pontos de solda",
	"b210": "Não foi possível criar o ponto de solda",
	"b211": "Parâmetro start ausente!",
	"b212": "O parâmetro start deve ser um número inteiro!",
	"b213": "Parâmetro end ausente!",
	"b214": "O parâmetro end deve ser um número inteiro!",
	"b215": "Valor de referência da largura de pulso",
	"b216": "Valor acumulado da largura de pulso",
	"b217": "Contagem da largura de pulso",
	"b218": "Falha ao enviar os dados do gerenciamento de pontos",
	"b219": "A contagem da largura de pulso só pode ser definida como 0",
	"b220": "A contagem da largura de pulso só pode ser zerada; ao zerá-la, o valor de referência e o valor acumulado da largura de pulso também serão zerados",
	"b221": "Os tipos dos dispositivos de origem e de destino não correspondem",
	"b222": "Central de funções",
	"b223": "Os parâmetros atuais do programa foram alterados, mas ainda não foram enviados ao dispositivo. Deseja sair sem enviar?",
	"b224": "Sair sem salvar",
	"r001": "Status do dispositivo",
	"r002": "Produção",
	"r003": "Fresagem",
	"r004": "Soldagem",
	"r005": "Verificação",
	"r006": "Teste de pressão",
	"r007": "Solda de teste",
	"r008": "Alarme",
	"r009": "Visualizar registros de alarmes",
	"r010": "Status de E/S",
	"r011": "Forma de onda de soldagem",
	"r012": "Informações do controlador",
	"r013": "Dados em tempo real",
	"r014": "Contagem de pontos por peça",
	"r015": "Produção do turno",
	"r016": "Produção total",
	"r017": "Total de pontos de solda",
	"r018": "Etapas de compensação executadas",
	"r019": "Fresagens executadas",
	"r020": "Tensão do barramento CC",
	"r021": "Contagem de expulsões do programa atual",
	"r022": "Contagem total de expulsões",
	"r023": "Versão de hardware do controlador",
	"r024": "Versão de software do controlador",
	"r025": "Versão do software CPLD",
	"r026": "Versão do bootloader",
	"r027": "Eletrodo",
	"r028": "Entrada",
	"r029": "Saída",
	"r030": "Sinal de partida 1",
	"r031": "Sinal de partida 2",
	"r032": "Seleção de programa 1",
	"r033": "Seleção de programa 2",
	"r034": "Seleção de programa 4",
	"r035": "Seleção de programa 8",
	"r036": "Seleção de programa 16",
	"r037": "Seleção de programa 32",
	"r038": "Verificação / soldagem",
	"r039": "Reset de alarme",
	"r040": "Produção / fresagem",
	"r041": "Parada de emergência",
	"r042": "Chave de temperatura do transformador",
	"r043": "Chave de temperatura do inversor",
	"r044": "Chave de fluxo de água",
	"r045": "Pressostato de ar",
	"r046": "Permissão de soldagem",
	"r047": "Reservado",
	"r048": "Reset de contagem",
	"r049": "Programa 64",
	"r050": "Programa 128",
	"r051": "Programa 256",
	"r052": "Programa 512",
	"r053": "Confirmação da fresagem do eletrodo",
	"r054": "Confirmação da troca do eletrodo",
	"r055": "Reservado 28",
	"r056": "Reservado 29",
	"r057": "Reservado 30",
	"r058": "Reservado 31",
	"r059": "Máquina pronta",
	"r060": "Válvula pneumática 1",
	"r061": "Válvula pneumática 2",
	"r062": "Válvula pneumática 3",
	"r063": "Válvula pneumática 4",
	"r064": "Soldagem concluída",
	"r065": "Disparo do IGBT",
	"r066": "Solicitação de soldagem",
	"r067": "Saída do motor",
	"r068": "Saída de alarme",
	"r069": "Fresagem do eletrodo",
	"r070": "Troca do eletrodo",
	"r071": "Válvula de fresagem",
	"r072": "Movimento concluído",
	"r073": "Reservado 20",
	"r074": "Reservado 21",
	"r075": "Reservado 22",
	"r076": "Reservado 23",
	"r077": "Reservado 24",
	"r078": "Reservado 25",
	"r079": "Reservado 26",
	"r080": "Reservado 27",
	"r081": "Corrente",
	"r082": "Tensão",
	"r083": "Resistência",
	"r084": "Pressão",
	"r085": "Configurações de aquisição",
	"r086": "Configurar",
	"r087": "Adquirir curva de corrente",
	"r088": "Adquirir curva de resistência",
	"r089": "Adquirir curva de tensão",
	"r090": "Adquirir curva de pressão",
	"r091": "Configuração salva com sucesso",
	"r092": "Falha ao atualizar as curvas de aquisição",
	"r093": "Curvas de aquisição atualizadas com sucesso",
	"r094": "Tipo de operação desconhecido",
	"r095": "Código do dispositivo inválido",
	"r096": "O dispositivo está offline; a operação não é permitida",
	"r097": "Operação concluída com sucesso",
	"r098": "Falha na operação",
	"r099": "{{.a}}: operação desconhecida",
	"r100": "Dados dos parâmetros de exibição não encontrados",
	"r101": "Dados de soldagem",
	"r102": "Dados estatísticos",
	"r103": "Contagem",
	"r104": "Visualizar",
	"r105": "Nº do registro de soldagem",
	"r106": "Versão de software do controlador",
	"r107": "Atualização do gerenciamento de pontos concluída com sucesso",
	"r108": "Falha na atualização do gerenciamento de pontos",
	"r109": "Os dados importados serão mesclados com os dados existentes. Deseja continuar?",
	"r110": "Erro ao consultar informações do ponto de solda",
	"r111": "Esta operação não é permitida no modo de solda de teste ou teste de pressão",
	"r112": "Esta operação não é permitida no modo de fresagem",
	"r113": "Função em desenvolvimento",
	"r114": "Arraste para selecionar uma área e ampliar o gráfico; clique duas vezes para restaurar o tamanho padrão",
	"r115": "Não foi possível ler o arquivo do sistema",
	"r116": "Confirmação de novo ponto de solda",
	"r117": "Seleção de novo ponto de solda",
	"r118": "Exibir ponto de expulsão",
	"r119": "Análise de tendência",
	"r120": "Visualizar parâmetros",
	"r121": "Tendência",
	"r122": "Corrente da solda 1 (kA)",
	"r123": "Corrente da solda 2 (kA)",
	"r124": "Corrente da solda 3 (kA)",
	"r125": "Limite de quantidade",
	"r126": "Parâmetros do programa informados inválidos",
	"r127": "Corrente de pré-soldagem (kA)",
	"r128": "Corrente de pós-soldagem (kA)",
	"r129": "UIP",
	"r130": "Separe vários números de programa por vírgula",
	"r131": "Informe o nº do programa",
	"r132": "O nº do programa deve ser um número inteiro",
	"r133": "O nº de mapeamento do ponto de solda deve ser um número inteiro",
	"r134": "Digite uma quantidade válida de pontos de solda",
	"r135": "O número de pontos em tempo real não pode exceder 1000",
	"r136": "Curva de soldagem",
	"r137": "Tempo real",
	"r138": "Histórico",
	"r139": "Nos dados em tempo real, só é possível consultar registros de soldagem da última semana",
	"r140": "O número de pontos históricos não pode exceder 10000",
	"r141": "Curva de resistência de referência",
	"r142": "Word baixo da referência de energia do programa",
	"r143": "Word alto da referência de energia do programa",
	"r144": "Referência de energia do programa",
	"r145": "Editar curva UIR",
	"r146": "Cortina de luz de segurança acionada",
	"r147": "Alarme do chiller",
	"r148": "Alarme da porta do painel de controle",
	"r149": "Falha do controlador de soldagem",
	"r150": "Pressão de entrada de ar anormal",
	"r151": "Fluxo de água anormal",
	"r152": "Temperatura da água anormal",
	"r153": "Alarme de limite superior da temperatura da água",
	"r154": "Alarme de limite inferior da temperatura da água",
	"r155": "Alarme de limite superior da pressão de soldagem",
	"r156": "Alarme de limite inferior da pressão de soldagem",
	"r157": "Alarme de limite superior de fusão",
	"r158": "Alarme de limite inferior de fusão",
	"r159": "Eletrodo 1 — eletrodo fixo: o pino de localização não avançou",
	"r160": "Eletrodo 1 — eletrodo fixo: o pino de localização não recuou",
	"r161": "Eletrodo 1 — eletrodo móvel: não está na posição inicial superior",
	"r162": "Eletrodo 1 — eletrodo móvel: não está na posição final inferior",
	"r163": "Eletrodo 1 — eletrodo móvel: não está na posição de pequena abertura",
	"r164": "Eletrodo 1 — eletrodo móvel: o pino de localização não avançou",
	"r165": "Eletrodo 1 — eletrodo móvel: o pino de localização não recuou",
	"r166": "Eletrodo 2 — eletrodo fixo: o pino de localização não avançou",
	"r167": "Eletrodo 2 — eletrodo fixo: o pino de localização não recuou",
	"r168": "Eletrodo 2 — eletrodo móvel: não está na posição inicial superior",
	"r169": "Eletrodo 2 — eletrodo móvel: não está na posição final inferior",
	"r170": "Eletrodo 2 — eletrodo móvel: não está na posição de pequena abertura",
	"r171": "Eletrodo 2 — eletrodo móvel: o pino de localização não avançou",
	"r172": "Eletrodo 2 — eletrodo móvel: o pino de localização não recuou",
	"r173": "Alimentador 1 fora da posição inicial",
	"r174": "Alimentador 2 fora da posição inicial",
	"r175": "Alimentador 3 fora da posição inicial",
	"r176": "Alimentador 4 fora da posição inicial",
	"r177": "Alimentador 1 fora da posição final",
	"r178": "Alimentador 2 fora da posição final",
	"r179": "Alimentador 3 fora da posição final",
	"r180": "Alimentador 4 fora da posição final",
	"r181": "Alimentador 1 alarme geral",
	"r182": "Alimentador 1 — falha: alarme de falta de material",
	"r183": "Alimentador 1 — falha: alarme do cilindro de elevação na posição final",
	"r184": "Alimentador 1 — falha: alarme do cilindro de elevação na posição inicial",
	"r185": "Alimentador 1 — falha: alarme da posição inicial",
	"r186": "Alimentador 1 — falha: alarme da posição final",
	"r187": "Alimentador 2 alarme geral",
	"r188": "Alimentador 2 — falha: alarme de falta de material",
	"r189": "Alimentador 2 — falha: alarme do cilindro de elevação na posição final",
	"r190": "Alimentador 2 — falha: alarme do cilindro de elevação na posição inicial",
	"r191": "Alimentador 2 — falha: alarme da posição inicial",
	"r192": "Alimentador 2 — falha: alarme da posição final",
	"r193": "Alimentador 3 alarme geral",
	"r194": "Alimentador 3 — falha: alarme de falta de material",
	"r195": "Alimentador 3 — falha: alarme do cilindro de elevação na posição final",
	"r196": "Alimentador 3 — falha: alarme do cilindro de elevação na posição inicial",
	"r197": "Alimentador 3 — falha: alarme da posição inicial",
	"r198": "Alimentador 3 — falha: alarme da posição final",
	"r199": "Alimentador 4 alarme geral",
	"r200": "Alimentador 4 — falha: alarme de falta de material",
	"r201": "Alimentador 4 — falha: alarme do cilindro de elevação na posição final",
	"r202": "Alimentador 4 — falha: alarme do cilindro de elevação na posição inicial",
	"r203": "Alimentador 4 — falha: alarme da posição inicial",
	"r204": "Alimentador 4 — falha: alarme da posição final",
	"r205": "Eletrodo 1 — eletrodo móvel: alarme de fresagem",
	"r206": "Eletrodo 1 — eletrodo fixo: alarme de fresagem",
	"r207": "Eletrodo 1 — eletrodo móvel: alarme de troca",
	"r208": "Eletrodo 1 — eletrodo fixo: alarme de troca",
	"r209": "Eletrodo 2 — eletrodo móvel: alarme de fresagem",
	"r210": "Eletrodo 2 — eletrodo fixo: alarme de fresagem",
	"r211": "Eletrodo 2 — eletrodo móvel: alarme de troca",
	"r212": "Eletrodo 2 — eletrodo fixo: alarme de troca",
	"r213": "Eletrodo 1 — detecção de montagem da porca/parafuso: verifique se a peça está ausente, inclinada ou se o modelo está incorreto",
	"r214": "Eletrodo 1 — detecção de montagem da porca/parafuso: verifique se há outro objeto empilhado sobre a porca/parafuso",
	"r215": "Eletrodo 1 — detecção de montagem da porca/parafuso: verifique se a porca está invertida ou se o modelo do parafuso está incorreto",
	"r216": "Eletrodo 2 — detecção de montagem da porca/parafuso: verifique se a peça está ausente, inclinada ou se o modelo está incorreto",
	"r217": "Eletrodo 2 — detecção de montagem da porca/parafuso: verifique se há outro objeto empilhado sobre a porca/parafuso",
	"r218": "Eletrodo 2 — detecção de montagem da porca/parafuso: verifique se a porca está invertida ou se o modelo do parafuso está incorreto",
	"r219": "A contagem de pontos da peça atingiu o limite. Zere a contagem.",
	"r220": "A função de pré-alimentação não está habilitada",
	"r221": "O sistema não está no modo de configuração de componentes",
	"r222": "O controlador de soldagem não está pronto",
	"r223": "Durante a fresagem, o sistema não está no modo de verificação",
	"r224": "Durante a calibração, o sistema não está no modo de verificação",
	"r225": "A alimentação pelo robô não foi concluída",
	"r226": "O sistema não está no modo automático",
	"r227": "O sistema não está no modo manual",
	"r228": "O sistema não está no modo online",
	"r229": "O sistema não está no modo autônomo",
	"r230": "O sistema não está no modo de fresagem",
	"r231": "O controle remoto não está habilitado",
	"r232": "O robô não está pronto",
	"r233": "O zero do eletrodo 1 não foi calibrado",
	"r234": "O zero do eletrodo 2 não foi calibrado",
	"r235": "O eletrodo 1 não está no modo remoto de fresagem",
	"r236": "O eletrodo 1 não está no modo remoto de produção",
	"r237": "O eletrodo 2 não está no modo remoto de fresagem",
	"r238": "O eletrodo 2 não está no modo remoto de produção",
	"r239": "Tempo limite da sequência automática: movimento do pino de localização antes da alimentação",
	"r240": "Tempo limite da sequência automática: pré-alimentação",
	"r241": "Tempo limite da sequência automática: alimentação pelo alimentador",
	"r242": "Tempo limite da sequência automática: movimento do pino de localização antes da pré-pressão",
	"r243": "Tempo limite da sequência automática: pré-pressão",
	"r244": "Tempo limite da sequência automática: detecção de porca/parafuso",
	"r245": "Tempo limite da sequência automática: pressurização",
	"r246": "Tempo limite da sequência automática: detecção de pressão",
	"r247": "Tempo limite da sequência automática: preparação antes da soldagem",
	"r248": "Tempo limite da sequência automática: permissão de descarga",
	"r249": "Tempo limite da sequência automática: soldagem",
	"r250": "Tempo limite da sequência automática: retenção de pressão",
	"r251": "Tempo limite da sequência automática: retorno",
	"r252": "Tempo limite da sequência automática: pulso de soldagem concluída",
	"r253": "Tempo limite da detecção da porca excedido",
	"r254": "Tempo limite da detecção da pressão de pressurização",
	"r255": "Tempo limite do retorno durante o reset do sistema",
	"r256": "Tempo limite do retorno durante o reset da sequência",
	"r257": "Tempo limite do registro de deslocamento: retorno",
	"r258": "Tempo limite do registro de posição: etapa de movimento do pino antes da alimentação",
	"r259": "Tempo limite do registro de posição: etapa de alimentação",
	"r260": "Tempo limite do registro de posição: movimento do pino antes da descida do eletrodo",
	"r261": "Tempo limite do registro de posição: etapa de calibração do zero",
	"r262": "Tempo limite do registro de posição: etapa de descida do eletrodo",
	"r263": "Tempo limite do registro de posição: etapa de filtragem",
	"r264": "Tempo limite do registro de posição: etapa de retorno",
	"r265": "Tempo limite do intervalo entre pontos da peça excedido (limpeza específica)",
	"r266": "Tempo limite de soldagem de uma peça excedido (limpeza específica)",
	"r267": "Erro de configuração da receita: no modo online, é obrigatório configurar o alimentador de porcas",
	"r268": "Erro de configuração da receita: o alimentador 1 não está instalado neste dispositivo",
	"r269": "Erro de configuração da receita: o alimentador 2 não está instalado neste dispositivo",
	"r270": "Erro de configuração da receita: o alimentador 3 não está instalado neste dispositivo",
	"r271": "Erro de configuração da receita: o alimentador 4 não está instalado neste dispositivo",
	"r272": "Erro de configuração da receita: o alimentador de porcas 1 não suporta o modo de trabalho selecionado",
	"r273": "Erro de configuração da receita: o alimentador de porcas 2 não suporta o modo de trabalho selecionado",
	"r274": "Erro de configuração da receita: o eletrodo 1 não possui sensor de deslocamento e não suporta a detecção de porca",
	"r275": "Erro de configuração da receita: o eletrodo 2 não possui sensor de deslocamento e não suporta a detecção de porca",
	"r276": "Erro de configuração da receita: o eletrodo 1 não possui sensor de pressão de ar nem célula de carga; não é possível medir a pressão de soldagem",
	"r277": "Erro de configuração da receita: o eletrodo 2 não possui sensor de pressão de ar nem célula de carga; não é possível medir a pressão de soldagem",
	"r278": "Erro de configuração da receita: o eletrodo 1 não possui pino de localização superior",
	"r279": "Erro de configuração da receita: o eletrodo 2 não possui pino de localização superior",
	"r280": "Erro de configuração da receita: o eletrodo 1 não possui válvula intensificadora de pressão",
	"r281": "Erro de configuração da receita: o eletrodo 2 não possui válvula intensificadora de pressão",
	"r282": "Erro de configuração da receita: o eletrodo 1 não suporta controle de curso",
	"r283": "Erro de configuração da receita: o eletrodo 2 não suporta controle de curso",
	"r284": "Erro de configuração da receita: nenhum alimentador foi configurado; a pré-alimentação não é suportada",
	"r285": "Valor de pré-pressão inválido na receita atual",
	"r286": "Valor de pressão de soldagem inválido na receita atual",
	"r287": "Valor da pressão de retorno inválido na receita atual",
	"r288": "A pressão de retorno da receita atual é inválida; neste ciclo será usada a pressão de retorno padrão do sistema",
	"r289": "Configuração inválida da pressão de retorno do eletrodo móvel",
	"r290": "Detecção de porca/parafuso: a pré-pressão da receita não pode ser 0",
	"r291": "Parâmetros do sistema: a pré-pressão manual não pode ser zero",
	"r292": "Parâmetros do sistema: a pressão manual de soldagem não pode ser zero",
	"r293": "Parâmetros do sistema: valor de pressão de fresagem inválido",
	"r294": "Parâmetros do sistema: valor de pré-pressão inválido",
	"r295": "Parâmetros do sistema: valor de pressão de soldagem inválido",
	"r296": "Parâmetros do sistema: unidade de pressão inválida",
	"r297": "O alimentador 1 não está instalado neste dispositivo",
	"r298": "O alimentador 2 não está instalado neste dispositivo",
	"r299": "O alimentador 3 não está instalado neste dispositivo",
	"r300": "O alimentador 4 não está instalado neste dispositivo",
	"r301": "O eletrodo 1 não possui pino de localização superior",
	"r302": "O eletrodo 1 não possui sensor de posição do eletrodo móvel",
	"r303": "O eletrodo 1 não possui sensor de posição do eletrodo fixo",
	"r304": "O eletrodo 1 não possui válvula de multiplicação de força",
	"r305": "O eletrodo 1 não possui válvula de curso",
	"r306": "O eletrodo 2 não possui pino de localização superior",
	"r307": "O eletrodo 2 não possui sensor de posição do eletrodo móvel",
	"r308": "O eletrodo 2 não possui sensor de posição do eletrodo fixo",
	"r309": "O eletrodo 2 não possui válvula de multiplicação de força",
	"r310": "O eletrodo 2 não possui válvula de curso",
	"r311": "Eletrodo 1 falha na aquisição da pressão",
	"r312": "Eletrodo 1 falha na fresagem",
	"r313": "Eletrodo 1 falha no registro da posição da porca/parafuso",
	"r314": "Eletrodo 1: falha ao registrar a posição inicial do eletrodo fixo",
	"r315": "Eletrodo 1: falha ao registrar o offset de fresagem do eletrodo fixo",
	"r316": "Eletrodo 1 falha na calibração do zero",
	"r317": "Eletrodo 1: falha no movimento do eletrodo móvel",
	"r318": "Eletrodo 1 — detecção de porca/parafuso: falha ao zerar o deslocamento do eletrodo superior",
	"r319": "Eletrodo 1 — detecção de porca/parafuso: falha ao zerar o deslocamento do pino de localização inferior",
	"r320": "Eletrodo 1 falha na pressurização manual",
	"r321": "Eletrodo 1 falha na pré-pressão manual",
	"r322": "Eletrodo 1 falha ao atualizar as informações do pino de localização",
	"r323": "Eletrodo 1 — registro da posição da porca/parafuso: falha ao atualizar o limite do pino de localização",
	"r324": "Eletrodo 2 falha na aquisição da pressão",
	"r325": "Eletrodo 2 falha na fresagem",
	"r326": "Eletrodo 2 falha no registro da posição da porca/parafuso",
	"r327": "Eletrodo 2: falha ao registrar a posição inicial do eletrodo fixo",
	"r328": "Eletrodo 2: falha ao registrar o offset de fresagem do eletrodo fixo",
	"r329": "Eletrodo 2 falha na calibração do zero",
	"r330": "Eletrodo 2: falha no movimento do eletrodo móvel",
	"r331": "Eletrodo 2 — detecção de porca/parafuso: falha ao zerar o deslocamento do eletrodo superior",
	"r332": "Eletrodo 2 — detecção de porca/parafuso: falha ao zerar o deslocamento do pino de localização inferior",
	"r333": "Eletrodo 2 falha na pressurização manual",
	"r334": "Eletrodo 2 falha na pré-pressão manual",
	"r335": "Eletrodo 2 falha ao atualizar as informações do pino de localização",
	"r336": "Falha ao iniciar a soldagem no controlador",
	"r337": "Falha ao salvar a receita. Verifique se os valores estão configurados corretamente.",
	"r338": "Falha ao ler a receita",
	"r339": "Falha ao salvar os parâmetros do sistema. Verifique se os valores estão configurados corretamente.",
	"r340": "Configuração de data/hora inválida",
	"r341": "Erro na calibração de data/hora",
	"r342": "O número da receita lida não corresponde ao número da receita de destino",
	"r343": "Configuração do alimentador inválida",
	"r344": "Comando desconhecido",
	"r345": "Número da receita inválido",
	"r346": "Configuração de componentes inválida",
	"r347": "Modo de partida desconhecido",
	"r348": "Falha ao salvar os parâmetros de calibração",
	"r349": "Falha ao zerar o novo ponto de solda da máquina",
	"r350": "Pontos de calibração insuficientes; são necessários pelo menos dois",
	"r351": "Erro ao importar os parâmetros do sistema",
	"r352": "Erro ao importar a tabela de configuração de hardware do dispositivo",
	"r353": "Erro ao importar os dados estatísticos de contagem",
	"r354": "Erro ao importar a receita",
	"r355": "Erro ao importar os parâmetros de calibração",
	"r356": "Erro de inicialização do mestre Modbus RTU 0",
	"r357": "Erro ao habilitar o mestre Modbus RTU 0",
	"r358": "Erro ao vincular o mestre Modbus RTU 0 ao gerenciador de tarefas",
	"r359": "Erro de XoneInit do mestre Modbus RTU 1",
	"r360": "Erro ao habilitar Xone no mestre Modbus RTU 1",
	"r361": "Erro ao vincular Xone do mestre Modbus RTU 1 ao gerenciador de tarefas",
	"r362": "Erro de inicialização do Modbus TCP",
	"r363": "Erro ao habilitar o Modbus TCP",
	"r364": "Erro ao iniciar o TIM7",
	"r365": "Erro de inicialização do log",
	"r366": "Erro de execução do log",
	"r367": "Erro ao iniciar o relógio de tempo real",
	"r368": "Erro de data/hora do relógio de tempo real",
	"r369": "Erro de inicialização das E/S digitais",
	"r370": "Erro de inicialização da máquina de estados",
	"r371": "Erro no gerenciamento de tarefas do mestre Modbus 0",
	"r372": "Erro no gerenciamento de tarefas Xone do mestre Modbus 1",
	"r373": "Erro na configuração do bloco de controle da máquina de solda",
	"r374": "Detecção de porca/parafuso: erro na configuração do deslocamento do eletrodo móvel",
	"r375": "Detecção de porca/parafuso: erro na configuração do deslocamento do pino do eletrodo fixo",
	"r376": "Falha ao executar o comando de controle da máquina de solda",
	"r377": "Falha na transmissão de dados do módulo DIO",
	"r378": "Falha de SPI do módulo DIO",
	"r379": "Falha na transmissão de dados do módulo ADC",
	"r380": "Falha de SPI do módulo ADC",
	"r381": "Falha de comunicação serial do módulo Anybus",
	"r382": "Falha de comunicação serial do módulo Modbus RTU",
	"r383": "Falta de energia do sistema detectada",
	"r384": "Falha ao salvar os dados estatísticos de contagem",
	"r385": "Falha ao validar os dados estatísticos de contagem",
	"r386": "Falha no módulo de partida bimanual",
	"r387": "Falha ao parar o temporizador regressivo",
	"r388": "Falha ao iniciar o temporizador regressivo",
	"r389": "Falha ao cancelar a inscrição no evento",
	"r390": "Falha ao assinar o evento",
	"r391": "Falha no registro de transição de estado",
	"r392": "Falha no controle da alimentação das E/S",
	"r393": "Falha ao sair do estado",
	"r394": "Falha ao entrar no estado",
	"r395": "Falha ao entrar no estado de alarme",
	"r396": "Falha ao sair do estado de alarme",
	"r397": "Falha ao atualizar as informações de controle da posição do pino",
	"r398": "Falha na indicação de estado",
	"r399": "Falha ao zerar os indicadores das entradas digitais",
	"r400": "Falha ao assinar os eventos das entradas digitais",
	"r401": "Alimentador 1 falha de controle",
	"r402": "Alimentador 2 falha de controle",
	"r403": "Alimentador 3 falha de controle",
	"r404": "Alimentador 4 falha de controle",
	"s001": "Registros do sistema",
	"s002": "Nº",
	"s003": "Operador",
	"s004": "Nº do objeto",
	"s005": "Resumo",
	"s006": "Data/hora da operação",
	"s007": "Status da etapa de calibração",
	"s008": "Seleção de etapa",
	"s009": "Habilitar controlador pronto e iniciar operação normal",
	"s010": "Habilitar soldagem do controlador",
	"s011": "Status das E/S do sistema supervisório",
	"s012": "Comando de limpeza de erro",
	"s013": "Valor ajustado da saída PWM de corrente",
	"s014": "Valor ajustado da saída de pressão do eletrodo",
	"s015": "Valor exibido da tensão do barramento CC",
	"s016": "Valor exibido da corrente primária",
	"s017": "Valor exibido da corrente secundária",
	"s018": "Valor exibido da pressão do eletrodo",
	"s019": "Comando de reset do contador de soldagem",
	"s020": "Word de status da entrada 00 do Profibus",
	"s021": "Word de status da entrada 01 do Profibus",
	"s022": "Word de status da saída 00 do Profibus",
	"s023": "Word de status da saída 01 do Profibus",
	"s024": "Word de status da entrada 00 do Devicenet",
	"s025": "Word de status da entrada 01 do Devicenet",
	"s026": "Word de status da saída 00 do Devicenet",
	"s027": "Word de status da saída 00 do Devicenet",
	"s028": "Clique ou arraste o arquivo aqui para enviar",
	"s029": "Importação concluída",
	"s030": "Atualizar",
	"s031": "Validar",
	"s032": "Limpar",
	"s033": "Criar ponto de solda",
	"s034": "Editar ponto de solda",
	"s035": "Reservado",
	"s036": "Ponteiro de endereço da tabela de alarmes históricos",
	"s037": "Word de status de alarme (0–31)",
	"s038": "Pressão de pré-soldagem",
	"s039": "Pressão de resfriamento 0",
	"s040": "Pressão da rampa de subida",
	"s041": "Pressão da solda 1",
	"s042": "Pressão de resfriamento 1",
	"s043": "Pressão de resfriamento 2",
	"s044": "Pressão da solda 3",
	"s045": "Pressão da rampa de descida",
	"s046": "Pressão de resfriamento 3",
	"s047": "Pressão de pós-soldagem",
	"s048": "Pressão de retenção",
	"s049": "Código do modelo em produção na pinça de solda 1, campo 00 (armazenado em ASCII)",
	"s050": "Código do modelo em produção na pinça de solda 1, campo 01 (armazenado em ASCII)",
	"s051": "Código do modelo em produção na pinça de solda 1, campo 02 (armazenado em ASCII)",
	"s052": "Código do modelo em produção na pinça de solda 1, campo 03 (armazenado em ASCII)",
	"s053": "Código do modelo em produção na pinça de solda 2, campo 00 (armazenado em ASCII)",
	"s054": "Código do modelo em produção na pinça de solda 2, campo 01 (armazenado em ASCII)",
	"s055": "Código do modelo em produção na pinça de solda 2, campo 02 (armazenado em ASCII)",
	"s056": "Código do modelo em produção na pinça de solda 2, campo 03 (armazenado em ASCII)",
	"s057": "Modo de pressão do eletrodo",
	"s058": "Habilitar função de partida 2",
	"s059": "Habilitar confirmação de ponto de solda",
	"s060": "Número de ressoldagens",
	"s061": "Pressão de teste",
	"s062": "Versão do software CPLD do controlador",
	"s063": "Seleção da interface de comunicação",
	"s064": "Endereço de comunicação",
	"s065": "Função de rede",
	"s066": "IP0",
	"s067": "IP1",
	"s068": "Número de série do dispositivo",
	"s069": "Taxa de transmissão DeviceNet",
	"s070": "Tensão nominal",
	"s071": "Número de inversores",
	"s072": "Habilitar função de permissão de soldagem",
	"s073": "Relação de espiras do transformador",
	"s074": "Eficiência do transformador",
	"s075": "Modo de controle de corrente constante",
	"s076": "Limite de corrente primária",
	"s077": "Controle de reset do alarme de proteção do IGBT",
	"s078": "Habilitar parada de emergência da HMI",
	"s079": "Habilitar prioridade do grupo de programas",
	"s080": "Habilitar válvula proporcional",
	"s081": "Habilitar operação do controlador sem a HMI",
	"s082": "Modo de acionamento para grande abertura",
	"s083": "Função de confirmação da fresagem do eletrodo",
	"s084": "Na soldagem com pinça suspensa, atrasar a partida da pequena abertura da pinça",
	"s085": "Coeficiente entre a amostra da bobina Rogowski e a corrente real da pinça de solda 1",
	"s086": "Coeficiente entre a amostra da bobina Rogowski e a corrente real da pinça de solda 2",
	"s087": "Coeficiente entre a amostra do TC e a corrente real da pinça de solda 1",
	"s088": "Coeficiente entre a amostra do TC e a corrente real da pinça de solda 2",
	"s089": "Corrente máxima real suportada pela pinça de solda 1",
	"s090": "Corrente máxima real suportada pela pinça de solda 2",
	"s091": "Ângulo atual do fator de potência da pinça de solda 1",
	"s092": "Ângulo atual do fator de potência da pinça de solda 2",
	"s093": "Ângulo atual de disparo da soldagem do sistema",
	"s094": "Estado de abertura do braço do eletrodo após desligar o controlador da pinça suspensa",
	"s095": "Modo de saída dos sinais “soldagem concluída” e “movimento concluído”",
	"s096": "Coeficiente de exibição da tensão do barramento CC; este parâmetro não precisa mais ser configurado",
	"s097": "Valor PWM mínimo ajustado da corrente primária da pinça de solda 1",
	"s098": "Valor PWM ajustado no ponto 1 da corrente primária da pinça de solda 1",
	"s099": "Valor PWM ajustado no ponto 2 da corrente primária da pinça de solda 1",
	"s100": "Valor PWM ajustado no ponto 3 da corrente primária da pinça de solda 1",
	"s101": "Valor PWM ajustado no ponto 4 da corrente primária da pinça de solda 1",
	"s102": "Valor PWM ajustado no ponto 5 da corrente primária da pinça de solda 1",
	"s103": "Valor PWM ajustado no ponto 6 da corrente primária da pinça de solda 1",
	"s104": "Valor PWM máximo ajustado da corrente primária da pinça de solda 1",
	"s105": "Valor amostrado mínimo da corrente primária da pinça de solda 1",
	"s106": "Valor amostrado no ponto 1 da corrente primária da pinça de solda 1",
	"s107": "Valor amostrado no ponto 2 da corrente primária da pinça de solda 1",
	"s108": "Valor amostrado no ponto 3 da corrente primária da pinça de solda 1",
	"s109": "Valor amostrado no ponto 4 da corrente primária da pinça de solda 1",
	"s110": "Valor amostrado no ponto 5 da corrente primária da pinça de solda 1",
	"s111": "Valor amostrado no ponto 6 da corrente primária da pinça de solda 1",
	"s112": "Valor amostrado máximo da corrente primária da pinça de solda 1",
	"s113": "Valor exibido mínimo da corrente primária da pinça de solda 1",
	"s114": "Valor exibido no ponto 1 da corrente primária da pinça de solda 1",
	"s115": "Valor exibido no ponto 2 da corrente primária da pinça de solda 1",
	"s116": "Valor exibido no ponto 3 da corrente primária da pinça de solda 1",
	"s117": "Valor exibido no ponto 4 da corrente primária da pinça de solda 1",
	"s118": "Valor exibido no ponto 5 da corrente primária da pinça de solda 1",
	"s119": "Valor exibido no ponto 6 da corrente primária da pinça de solda 1",
	"s120": "Valor exibido máximo da corrente primária da pinça de solda 1",
	"s121": "Valor PWM mínimo ajustado da corrente secundária da pinça de solda 1",
	"s122": "Valor PWM ajustado no ponto 1 da corrente secundária da pinça de solda 1",
	"s123": "Valor PWM ajustado no ponto 2 da corrente secundária da pinça de solda 1",
	"s124": "Valor PWM ajustado no ponto 3 da corrente secundária da pinça de solda 1",
	"s125": "Valor PWM ajustado no ponto 4 da corrente secundária da pinça de solda 1",
	"s126": "Valor PWM ajustado no ponto 5 da corrente secundária da pinça de solda 1",
	"s127": "Valor PWM ajustado no ponto 6 da corrente secundária da pinça de solda 1",
	"s128": "Valor PWM máximo ajustado da corrente secundária da pinça de solda 1",
	"s129": "Valor amostrado mínimo da corrente secundária da pinça de solda 1",
	"s130": "Valor amostrado no ponto 1 da corrente secundária da pinça de solda 1",
	"s131": "Valor amostrado no ponto 2 da corrente secundária da pinça de solda 1",
	"s132": "Valor amostrado no ponto 3 da corrente secundária da pinça de solda 1",
	"s133": "Valor amostrado no ponto 4 da corrente secundária da pinça de solda 1",
	"s134": "Valor amostrado no ponto 5 da corrente secundária da pinça de solda 1",
	"s135": "Valor amostrado no ponto 6 da corrente secundária da pinça de solda 1",
	"s136": "Valor amostrado máximo da corrente secundária da pinça de solda 1",
	"s137": "Valor exibido mínimo da corrente secundária da pinça de solda 1",
	"s138": "Valor exibido no ponto 1 da corrente secundária da pinça de solda 1",
	"s139": "Valor exibido no ponto 2 da corrente secundária da pinça de solda 1",
	"s140": "Valor exibido no ponto 3 da corrente secundária da pinça de solda 1",
	"s141": "Valor exibido no ponto 4 da corrente secundária da pinça de solda 1",
	"s142": "Valor exibido no ponto 5 da corrente secundária da pinça de solda 1",
	"s143": "Valor exibido no ponto 6 da corrente secundária da pinça de solda 1",
	"s144": "Valor exibido máximo da corrente secundária da pinça de solda 1",
	"s145": "Valor PWM mínimo ajustado da corrente secundária da pinça de solda 2",
	"s146": "Valor PWM ajustado no ponto 1 da corrente secundária da pinça de solda 2",
	"s147": "Valor PWM ajustado no ponto 2 da corrente secundária da pinça de solda 2",
	"s148": "Valor PWM ajustado no ponto 3 da corrente secundária da pinça de solda 2",
	"s149": "Valor PWM ajustado no ponto 4 da corrente secundária da pinça de solda 2",
	"s150": "Valor PWM ajustado no ponto 5 da corrente secundária da pinça de solda 2",
	"s151": "Valor PWM ajustado no ponto 6 da corrente secundária da pinça de solda 2",
	"s152": "Valor PWM máximo ajustado da corrente secundária da pinça de solda 2",
	"s153": "Valor amostrado mínimo da corrente secundária da pinça de solda 2",
	"s154": "Valor amostrado no ponto 1 da corrente secundária da pinça de solda 2",
	"s155": "Valor amostrado no ponto 2 da corrente secundária da pinça de solda 2",
	"s156": "Valor amostrado no ponto 3 da corrente secundária da pinça de solda 2",
	"s157": "Valor amostrado no ponto 4 da corrente secundária da pinça de solda 2",
	"s158": "Valor amostrado no ponto 5 da corrente secundária da pinça de solda 2",
	"s159": "Valor amostrado no ponto 6 da corrente secundária da pinça de solda 2",
	"s160": "Valor amostrado máximo da corrente secundária da pinça de solda 2",
	"s161": "Valor exibido mínimo da corrente secundária da pinça de solda 2",
	"s162": "Valor exibido no ponto 1 da corrente secundária da pinça de solda 2",
	"s163": "Valor exibido no ponto 2 da corrente secundária da pinça de solda 2",
	"s164": "Valor exibido no ponto 3 da corrente secundária da pinça de solda 2",
	"s165": "Valor exibido no ponto 4 da corrente secundária da pinça de solda 2",
	"s166": "Valor exibido no ponto 5 da corrente secundária da pinça de solda 2",
	"s167": "Valor exibido no ponto 6 da corrente secundária da pinça de solda 2",
	"s168": "Valor exibido máximo da corrente secundária da pinça de solda 2",
	"s169": "Valor ajustado da saída de pressão do eletrodo, ponto 1, pinça de solda 1",
	"s170": "Valor ajustado da saída de pressão do eletrodo, ponto 2, pinça de solda 1",
	"s171": "Valor medido/exibido da pressão do eletrodo, ponto 1, pinça de solda 1",
	"s172": "Valor medido/exibido da pressão do eletrodo, ponto 2, pinça de solda 1",
	"s173": "Valor ajustado da saída de pressão do eletrodo, ponto 1, pinça de solda 2",
	"s174": "Valor ajustado da saída de pressão do eletrodo, ponto 2, pinça de solda 2",
	"s175": "Valor medido/exibido da pressão do eletrodo, ponto 1, pinça de solda 2",
	"s176": "Valor medido/exibido da pressão do eletrodo, ponto 2, pinça de solda 2",
	"s177": "Parâmetros de calibração da corrente primária",
	"s178": "Parâmetros de calibração da corrente secundária",
	"s179": "Modo de seleção do programa de soldagem",
	"s180": "Parâmetro de ajuste fino da corrente constante no primário da pinça de solda 1",
	"s181": "Parâmetro de ajuste fino da corrente constante no secundário da pinça de solda 1",
	"s182": "Parâmetro de ajuste fino da corrente constante no primário da pinça de solda 2",
	"s183": "Parâmetro de ajuste fino da corrente constante no secundário da pinça de solda 2",
	"s184": "Pressão de subida da fresagem da pinça B",
	"s185": "Pressão de fresagem da pinça B",
	"s186": "Função de controle dos pontos de processo da pinça de solda 1",
	"s187": "Função de controle dos pontos de processo da pinça de solda 2",
	"s188": "Habilitar alarme quando a contagem de pontos da peça atingir a quantidade de processo",
	"s189": "Habilitar alarme da contagem de pontos da produção do turno",
	"s190": "Iniciar temporização imediatamente após o reset do alarme",
	"s191": "Tempo de determinação do fim do ciclo de soldagem da pinça de solda 1",
	"s192": "Tempo de determinação do fim do ciclo de soldagem da pinça de solda 2",
	"s193": "Valor ajustado do limite inferior de pontos por peça da pinça de solda 1",
	"s194": "Valor ajustado do limite inferior de pontos por peça da pinça de solda 2",
	"s195": "Valor ajustado do limite superior de pontos por peça da pinça de solda 1",
	"s196": "Valor ajustado do limite superior de pontos por peça da pinça de solda 2",
	"s197": "Valor ajustado da produção do turno da pinça de solda 1",
	"s198": "Valor ajustado da produção do turno da pinça de solda 2",
	"s199": "Contagem de pontos por peça da pinça de solda 1",
	"s200": "Contagem de pontos por peça da pinça de solda 2",
	"s201": "Valor de alarme salvo pelo contador na falta de energia",
	"s202": "Modo de configuração do número de pinças",
	"s203": "Valor ajustado do número de etapas de compensação da pinça de solda 1",
	"s204": "Valor ajustado do número de etapas de compensação da pinça de solda 2",
	"s205": "Valor ajustado do número de fresagens da pinça de solda 1",
	"s206": "Valor ajustado do número de fresagens da pinça de solda 2",
	"s207": "Valor ajustado de pontos para pré-alarme de fresagem da pinça de solda 1",
	"s208": "Valor ajustado de pontos para pré-alarme de fresagem da pinça de solda 2",
	"s209": "Número de pontos da etapa 1 da compensação escalonada da pinça de solda 1",
	"s210": "Compensação de potência da etapa 1 da pinça de solda 1",
	"s211": "Compensação de pressão da etapa 1 da pinça de solda 1",
	"s212": "Número de pontos da etapa 2 da compensação escalonada da pinça de solda 1",
	"s213": "Compensação de potência da etapa 2 da pinça de solda 1",
	"s214": "Compensação de pressão da etapa 2 da pinça de solda 1",
	"s215": "Número de pontos da etapa 3 da compensação escalonada da pinça de solda 1",
	"s216": "Compensação de potência da etapa 3 da pinça de solda 1",
	"s217": "Compensação de pressão da etapa 3 da pinça de solda 1",
	"s218": "Número de pontos da etapa 4 da compensação escalonada da pinça de solda 1",
	"s219": "Compensação de potência da etapa 4 da pinça de solda 1",
	"s220": "Compensação de pressão da etapa 4 da pinça de solda 1",
	"s221": "Número de pontos da etapa 5 da compensação escalonada da pinça de solda 1",
	"s222": "Compensação de potência da etapa 5 da pinça de solda 1",
	"s223": "Compensação de pressão da etapa 5 da pinça de solda 1",
	"s224": "Número de pontos da etapa 6 da compensação escalonada da pinça de solda 1",
	"s225": "Compensação de potência da etapa 6 da pinça de solda 1",
	"s226": "Compensação de pressão da etapa 6 da pinça de solda 1",
	"s227": "Número de pontos da etapa 7 da compensação escalonada da pinça de solda 1",
	"s228": "Compensação de potência da etapa 7 da pinça de solda 1",
	"s229": "Compensação de pressão da etapa 7 da pinça de solda 1",
	"s230": "Número de pontos da etapa 8 da compensação escalonada da pinça de solda 1",
	"s231": "Compensação de potência da etapa 8 da pinça de solda 1",
	"s232": "Compensação de pressão da etapa 8 da pinça de solda 1",
	"s233": "Número de pontos da etapa 9 da compensação escalonada da pinça de solda 1",
	"s234": "Compensação de potência da etapa 9 da pinça de solda 1",
	"s235": "Compensação de pressão da etapa 9 da pinça de solda 1",
	"s236": "Número de pontos da etapa 1 da compensação escalonada da pinça de solda 2",
	"s237": "Compensação de potência da etapa 1 da pinça de solda 2",
	"s238": "Compensação de pressão da etapa 1 da pinça de solda 2",
	"s239": "Número de pontos da etapa 2 da compensação escalonada da pinça de solda 2",
	"s240": "Compensação de potência da etapa 2 da pinça de solda 2",
	"s241": "Compensação de pressão da etapa 2 da pinça de solda 2",
	"s242": "Número de pontos da etapa 3 da compensação escalonada da pinça de solda 2",
	"s243": "Compensação de potência da etapa 3 da pinça de solda 2",
	"s244": "Compensação de pressão da etapa 3 da pinça de solda 2",
	"s245": "Número de pontos da etapa 4 da compensação escalonada da pinça de solda 2",
	"s246": "Compensação de potência da etapa 4 da pinça de solda 2",
	"s247": "Compensação de pressão da etapa 4 da pinça de solda 2",
	"s248": "Número de pontos da etapa 5 da compensação escalonada da pinça de solda 2",
	"s249": "Compensação de potência da etapa 5 da pinça de solda 2",
	"s250": "Compensação de pressão da etapa 5 da pinça de solda 2",
	"s251": "Número de pontos da etapa 6 da compensação escalonada da pinça de solda 2",
	"s252": "Compensação de potência da etapa 6 da pinça de solda 2",
	"s253": "Compensação de pressão da etapa 6 da pinça de solda 2",
	"s254": "Número de pontos da etapa 7 da compensação escalonada da pinça de solda 2",
	"s255": "Compensação de potência da etapa 7 da pinça de solda 2",
	"s256": "Compensação de pressão da etapa 7 da pinça de solda 2",
	"s257": "Número de pontos da etapa 8 da compensação escalonada da pinça de solda 2",
	"s258": "Compensação de potência da etapa 8 da pinça de solda 2",
	"s259": "Compensação de pressão da etapa 8 da pinça de solda 2",
	"s260": "Número de pontos da etapa 9 da compensação escalonada da pinça de solda 2",
	"s261": "Compensação de potência da etapa 9 da pinça de solda 2",
	"s262": "Compensação de pressão da etapa 9 da pinça de solda 2",
	"s263": "Valor PWM mínimo ajustado da corrente primária da pinça de solda 2",
	"s264": "Valor PWM ajustado no ponto 1 da corrente primária da pinça de solda 2",
	"s265": "Valor PWM ajustado no ponto 2 da corrente primária da pinça de solda 2",
	"s266": "Valor PWM ajustado no ponto 3 da corrente primária da pinça de solda 2",
	"s267": "Valor PWM ajustado no ponto 4 da corrente primária da pinça de solda 2",
	"s268": "Valor PWM ajustado no ponto 5 da corrente primária da pinça de solda 2",
	"s269": "Valor PWM ajustado no ponto 6 da corrente primária da pinça de solda 2",
	"s270": "Valor PWM máximo ajustado da corrente primária da pinça de solda 2",
	"s271": "Valor amostrado mínimo da corrente primária da pinça de solda 2",
	"s272": "Valor amostrado no ponto 1 da corrente primária da pinça de solda 2",
	"s273": "Valor amostrado no ponto 2 da corrente primária da pinça de solda 2",
	"s274": "Valor amostrado no ponto 3 da corrente primária da pinça de solda 2",
	"s275": "Valor amostrado no ponto 4 da corrente primária da pinça de solda 2",
	"s276": "Valor amostrado no ponto 5 da corrente primária da pinça de solda 2",
	"s277": "Valor amostrado no ponto 6 da corrente primária da pinça de solda 2",
	"s278": "Valor amostrado máximo da corrente primária da pinça de solda 2",
	"s279": "Valor exibido mínimo da corrente primária da pinça de solda 2",
	"s280": "Valor exibido no ponto 1 da corrente primária da pinça de solda 2",
	"s281": "Valor exibido no ponto 2 da corrente primária da pinça de solda 2",
	"s282": "Valor exibido no ponto 3 da corrente primária da pinça de solda 2",
	"s283": "Valor exibido no ponto 4 da corrente primária da pinça de solda 2",
	"s284": "Valor exibido no ponto 5 da corrente primária da pinça de solda 2",
	"s285": "Valor exibido no ponto 6 da corrente primária da pinça de solda 2",
	"s286": "Valor exibido máximo da corrente primária da pinça de solda 2",
	"s287": "16 bits altos do valor de alarme salvo pelo contador na falta de energia",
	"s288": "Habilitar ajuste UIR",
	"s289": "Habilitar extensão do tempo de soldagem durante o ajuste UIR",
	"s290": "Instante inicial do ajuste UIR",
	"s291": "Percentual máximo de aumento de corrente no ajuste UIR",
	"s292": "Percentual máximo de redução de corrente no ajuste UIR",
	"s293": "Percentual máximo de aumento do tempo no ajuste UIR",
	"s294": "Coeficiente de conversão da amostra de tensão secundária para o valor exibido",
	"s295": "Habilitar monitoramento UIR",
	"s296": "Habilitar registro de soldagem no cartão SD",
	"s297": "Número de registros de soldagem por arquivo no cartão SD",
	"s298": "Número de arquivos de soldagem por pasta no cartão SD",
	"s299": "Controle duplo da grande abertura para pinça suspensa",
	"s300": "Monitoramento da resistência secundária — 0: desligado; 1: ligado",
	"s301": "Uso global dos limites de resistência — 0: desligado; 1: ligado",
	"s302": "Endereço de offset interno",
	"s303": "Tensão do barramento CC durante a calibração de corrente",
	"s304": "Detecção de presença da tensão secundária",
	"s305": "Intervalo de tempo",
	"s306": "Últimos 30 dias",
	"s307": "Últimos 60 dias",
	"s308": "Últimos 90 dias",
	"s309": "curvas",
	"s310": "Intervalo de tempo inválido",
	"s311": "Curva ativa definida com sucesso",
	"s312": "A curva selecionada não é válida",
	"s313": "Número da curva inválido",
	"s314": "A curva correspondente não foi encontrada; falha na exclusão",
	"s315": "Falha ao excluir",
	"s316": "Excluído com sucesso",
	"s317": "Amostras insuficientes para gerar a curva de referência",
	"s318": "Deseja enviar a curva de referência atual ao controlador?",
	"s319": "Deseja salvar a curva de referência atual na biblioteca de programas?",
	"s320": "A curva de referência ainda não foi gerada e não pode ser enviada",
	"s321": "Número do programa inválido (0–143)",
	"s322": "Erro nos dados da curva",
	"s323": "Os dados da curva de referência estão vazios; não é possível salvar",
	"s324": "Erro ao processar a curva de referência",
	"s325": "Erro ao salvar a curva de referência",
	"s326": "Lista de alarmes",
	"s327": "Falha na execução",
	"s328": "Execução concluída com sucesso",
	"s329": "Falha na validação",
	"s330": "Executando...",
	"s331": "Como o modo de limite de corrente é percentual, {{.a}} só pode ser definido como inteiro. Verifique e, se a alteração não entrar em vigor, reconecte o dispositivo.",
	"s332": "O sistema está no modo de depuração. Encerre a depuração antes de sair.",
	"s333": "Modo de ajuste do algoritmo de corrente",
	"s334": "Rápido",
	"s335": "Ponto final",
	"s336": "Configuração do sistema",
	"s337": "Número de operações paralelas de backup/restauração de parâmetros",
	"s338": "Diretório de arquivos do HRC-670",
	"s339": "Porta de conexão do HRC-670",
	"s340": "Visualizar configuração do sistema",
	"s341": "Gerenciar configuração do sistema",
	"s342": "Erro ao salvar os parâmetros. Tente novamente mais tarde.",
	"s343": "Erro ao obter configuração do sistema. Tente novamente mais tarde.",
	"s344": "Configuração salva com sucesso",
	"s345": "O diretório de arquivos do HRC-670 não pode ficar em branco",
	"s346": "O diretório de arquivos do HRC-670 não existe!",
	"s347": "O número de operações paralelas de backup/restauração deve ser um inteiro positivo",
	"s348": "O número de operações paralelas de backup/restauração deve estar entre 1 e 8",
	"s349": "Compatível com operação sem mapeamento de pontos",
	"s350": "Luz indicadora",
	"s351": "Status do registro",
	"i001": "Gerenciamento de dados",
	"i002": "Limpar dados",
	"i003": "Registros de soldagem",
	"i004": "Registros de curvas",
	"i005": "Registros de alarmes",
	"i006": "Curva UIR de referência",
	"i007": "Dados da biblioteca de programas",
	"i008": "Dados em cache dos programas",
	"i009": "Dados em cache do sistema",
	"i010": "Histórico de alterações",
	"i011": "Registros do sistema",
	"i012": "Atenção: após apagar os dados, eles não poderão ser recuperados. Faça um backup antes de prosseguir!",
	"i013": "O usuário “{{.a}}” apagou os dados de {{.b}}",
	"i014": "Dados apagados com sucesso",
	"i015": "Falha ao apagar os dados",
	"i016": "Limpar por período",
	"i017": "1 mês",
	"i018": "3 meses",
	"i019": "6 meses",
	"i020": "1 ano",
	"i021": "Período de limpeza:",
	"i022": "Limpeza não baseada em período",
	"i023": "O usuário “{{.a}}” limpou os dados de {{.b}}; faixa da limpeza:",
	"i024": "Backup automático dos parâmetros do dispositivo",
	"i025": "Após habilitar o backup automático do dispositivo, selecione o horário do backup",
	"i026": "Retenção rotativa de registros",
	"i027": "Ao habilitar a limpeza automática, selecione os registros a limpar",
	"i028": "Ao habilitar a limpeza automática, selecione o intervalo de retenção",
	"i029": "A limpeza desta página é executada manualmente uma única vez. Para configurar a limpeza automática, acesse Sistema → Configuração do sistema, habilite “Retenção rotativa de registros” e salve a configuração.",
	"i030": "Servidor TCP",
	"i031": "Servidor SSH",
	"i032": "Excluir permanentemente",
	"i033": "Deseja excluir este dispositivo? Os dados não poderão ser recuperados.",
	"i034": "1 semana",
	"h001": "O usuário “{{.a}}” atualizou a biblioteca de programas “{{.b}}” (nome do programa: “{{.c}}”)",
	"h002": "Erro ao obter os registros do sistema. Tente novamente mais tarde.",
	"h003": "O usuário “{{.a}}” criou a biblioteca de programas “{{.b}}” (nome do programa: “{{.c}}”)",
	"h004": "O usuário “{{.a}}” excluiu a biblioteca de programas “{{.b}}” (nome do programa: “{{.c}}”)",
	"h005": "O usuário “{{.a}}” criou a área “{{.b}}”",
	"h006": "O usuário “{{.a}}” atualizou a área “{{.b}}”",
	"h007": "O usuário “{{.a}}” excluiu a área “{{.b}}”",
	"h008": "O usuário “{{.a}}” restaurou a área “{{.b}}”",
	"h009": "O usuário “{{.a}}” criou o dispositivo “{{.b}}”",
	"h010": "O usuário “{{.a}}” atualizou o dispositivo “{{.b}}”",
	"h011": "O usuário “{{.a}}” excluiu o dispositivo “{{.b}}”",
	"h012": "O usuário “{{.a}}” restaurou o dispositivo “{{.b}}”",
	"h013": "O usuário “{{.a}}” criou o usuário “{{.b}}”",
	"h014": "O usuário “{{.a}}” atualizou o usuário “{{.b}}”",
	"h015": "O usuário “{{.a}}” excluiu o usuário “{{.b}}”",
	"h016": "O usuário “{{.a}}” restaurou o usuário “{{.b}}”",
	"h017": "A conta “{{.b}}” foi bloqueada por 20 minutos após mais de {{.a}} tentativas de senha incorreta",
	"h018": "O usuário “{{.a}}” entrou no sistema com sucesso",
	"h019": "O usuário “{{.a}}” atualizou as configurações de aquisição de curvas do dispositivo “{{.b}}”",
	"h020": "O usuário “{{.a}}” criou o perfil “{{.b}}”",
	"h021": "O usuário “{{.a}}” atualizou o perfil “{{.b}}”",
	"h022": "O usuário “{{.a}}” excluiu o perfil “{{.b}}”",
	"h023": "O usuário “{{.a}}” restaurou o perfil “{{.b}}”",
	"h024": "O usuário “{{.a}}” alterou as permissões do perfil “{{.b}}”",
	"k001": "Monitoramento em tempo real",
	"k002": "Parâmetros do programa",
	"k003": "Gerenciamento da produção",
	"k004": "Parâmetros do sistema",
	"k005": "Registros de soldagem",
	"k006": "Registros de alarmes",
	"k007": "Histórico de alterações",
	"k008": "Gerenciamento de pontos de solda",
	"k009": "Dispositivo",
	"k010": "Biblioteca offline",
	"k011": "Seleção da pinça de solda",
	"k012": "Contagem de expulsões",
	"k013": "Limite de detecção de expulsão",
	"k014": "Limite da janela temporal de expulsão",
	"k015": "Valor de referência da resistência",
	"k016": "Limite mínimo da resistência de soldagem",
	"k017": "Limite máximo da resistência de soldagem",
	"k018": "Nº do programa inválido",
	"k019": "Programa “{{.a}}” carregado do dispositivo com sucesso",
	"k020": "Falha ao carregar o programa “{{.a}}” do dispositivo",
	"k021": "Programa “{{.a}}” carregado do banco de dados offline com sucesso",
	"k022": "Falha ao carregar o programa “{{.a}}” do banco de dados offline",
	"k023": "Enviar",
	"k024": "Dispositivo → biblioteca",
	"k025": "Exportar",
	"k026": "Importar",
	"k027": "Calibração do eletrodo 1",
	"k028": "Calibração do eletrodo 2",
	"k029": "Calibração do eletrodo 3",
	"k030": "Calibração do eletrodo 4",
	"k031": "Calibração do eletrodo 5",
	"k032": "Configuração UIR",
	"k033": "Curva UIR",
	"k034": "Gráfico retangular UIP",
	"k035": "Atualização de software",
	"k036": "Backup dos parâmetros do sistema",
	"k037": "Configuração da máquina de solda",
	"k038": "Tipo de máquina de solda",
	"k039": "Soldagem a ponto convencional",
	"k040": "Soldagem a ponto robotizada",
	"k041": "Soldagem por costura convencional",
	"k042": "Soldagem por costura dedicada",
	"k043": "Soldagem com pinça suspensa",
	"k044": "Soldagem personalizada",
	"k045": "Soldagem por projeção",
	"k046": "Soldagem com pinça suspensa BYD",
	"k047": "Confirmação do ponto de solda",
	"k048": "Fechar",
	"k049": "Ativado",
	"k050": "Tipo de transformador",
	"k051": "Confirmação da fresagem do eletrodo",
	"k052": "Sinal de soldagem concluída",
	"k053": "Pulso",
	"k054": "Nível mantido",
	"k055": "Seleção do modo de limite de corrente",
	"k056": "Modo de valor absoluto",
	"k057": "Modo percentual",
	"k058": "Modo de alarme UIP",
	"k059": "Aviso",
	"k060": "Parada da máquina",
	"k061": "Tensão mínima do barramento CC",
	"k062": "Modo de soldagem contínua",
	"k063": "Tensão de referência do barramento CC",
	"k064": "Controle de corrente constante",
	"k065": "Corrente constante no secundário",
	"k066": "Corrente constante no primário",
	"k067": "Pressão máxima do eletrodo",
	"k068": "Frequência de saída do inversor",
	"k069": "Configuração de funções",
	"k070": "Parada de emergência da HMI",
	"k071": "Função da válvula proporcional",
	"k072": "Prioridade do programa",
	"k073": "Controlador independente da HMI",
	"k074": "Configuração inicial",
	"k075": "Seleção de calibração",
	"k076": "Calibrar pressão do eletrodo",
	"k077": "Calibrar corrente primária",
	"k078": "Calibrar corrente secundária",
	"k079": "Valor de calibração",
	"k080": "Valor ajustado (%)",
	"k081": "Valor medido (kN)",
	"k082": "Seleção de função",
	"k083": "Monitoramento UIR",
	"k084": "Compensação de tempo",
	"k085": "Tempo inicial",
	"k086": "Parâmetros da função",
	"k087": "Limite superior do ajuste de corrente",
	"k088": "Limite inferior do ajuste de corrente",
	"k089": "Limite da janela temporal de expulsão",
	"k090": "Limite de detecção de expulsão",
	"k091": "Limite de extensão do tempo",
	"k092": "Coeficiente da tensão secundária",
	"k093": "Uso global dos limites de resistência",
	"k094": "Monitoramento da resistência secundária",
	"k095": "Limite mínimo da resistência de soldagem",
	"k096": "Limite máximo da resistência de soldagem",
	"k097": "Limite de extensão do tempo",
	"k098": "Parar registro UIR",
	"k099": "Número de pontos de solda",
	"k100": "Curva selecionada",
	"k101": "Tempo de soldagem",
	"k102": "Nº do ponto de solda",
	"k103": "Excluir curva",
	"k104": "Gerar curva de referência",
	"k105": "→ Controlador",
	"k106": "Habilitar função UIP",
	"k107": "Valor de referência UIP",
	"k108": "Faixa de tolerância superior do UIP",
	"k109": "Faixa de tolerância inferior do UIP",
	"k110": "Atualização do controlador",
	"k111": "Observação: o controlador só pode ser atualizado em standby. Não desligue a alimentação durante a atualização e reinicie o controlador ao concluir.",
	"k112": "Firmware",
	"k113": "Selecione o arquivo de firmware para atualização",
	"k114": "Selecionar arquivo",
	"k115": "Atualizar",
	"k116": "Restaurar padrões de fábrica",
	"k117": "Observação: o controlador será restaurado aos padrões de fábrica e os dados existentes serão perdidos",
	"k118": "Opções",
	"k119": "Parâmetros do sistema",
	"k120": "Restaurar",
	"k121": "Parâmetros de calibração",
	"k122": "Impedância do circuito secundário",
	"k123": "Permissão de soldagem",
	"k124": "Corrente secundária máxima",
	"k125": "Modo de saída de pressão",
	"k126": "Tempo máximo de soldagem",
	"k127": "Faixa máxima de variação da largura de pulso",
	"k128": "Impedância normal",
	"k129": "Impedância alta",
	"k130": "Impedância baixa",
	"k131": "Função de controle de E/S",
	"k132": "Prioridade do controlador",
	"k133": "Prioridade RS-485",
	"k134": "Prioridade DeviceNet",
	"k135": "Prioridade Modbus TCP",
	"k136": "Prioridade ABCC",
	"k137": "Prioridade do modo de trabalho",
	"k138": "Prioridade do programador",
	"k139": "Prioridade válida",
	"k140": "Prioridade do grupo de programas",
	"k141": "Configuração UIP",
	"k142": "Carregado do dispositivo com sucesso",
	"k143": "Carregado da biblioteca offline com sucesso",
	"k144": "Falha ao carregar do dispositivo",
	"k145": "Falha ao carregar da biblioteca offline",
	"k146": "Detecção da tensão secundária",
	"k147": "Detecção da tensão secundária",
	"k148": "Ajuste UIR",
	"k149": "Frequência do inversor",
	"k150": "Seleção da calibração da corrente primária",
	"k151": "Padrão do sistema",
	"k152": "Calibração pelo usuário",
	"k153": "Frequência do inversor",
	"k154": "Coeficiente de ajuste fino do primário",
	"k155": "Seleção da calibração da corrente secundária",
	"k156": "Ajuste PWM",
	"k157": "Valor medido (kA)",
	"k158": "Valor amostrado",
	"k159": "Coeficiente de ajuste fino do primário",
	"k160": "Coeficiente de ajuste fino do secundário",
	"k161": "Coeficiente de ajuste fino do secundário",
	"k162": "Valor de calibração do primário",
	"k163": "Valor de calibração do secundário",
	"k164": "Pressão do eletrodo",
	"k165": "Primário do eletrodo",
	"k166": "Secundário do eletrodo",
	"k167": "Contador do eletrodo 1",
	"k168": "Contador do eletrodo 2",
	"k169": "Fresagem do eletrodo 1",
	"k170": "Fresagem do eletrodo 2",
	"k171": "Informações da peça",
	"k172": "Lote de produção",
	"k173": "Operador",
	"k174": "Programa da partida 1",
	"k175": "Programa da partida 2",
	"k176": "Consultar",
	"k177": "Número de níveis vinculados do programa",
	"k178": "Atraso da partida até a pré-pressão",
	"k179": "Seleção da função",
	"k180": "Compensação escalonada",
	"k181": "Compensação de potência (%)",
	"k182": "Função de ressoldagem",
	"k183": "Função de verificação",
	"k184": "Número máximo de ressoldagens",
	"k185": "Função de partida 2",
	"k186": "Alarme do contador de pontos por peça",
	"k187": "Alarme da contagem de produção do turno",
	"k188": "Iniciar temporização imediatamente após o reset do alarme",
	"k189": "Controle dos pontos de processo da pinça",
	"k190": "Limite inferior de pontos de processo da pinça",
	"k191": "Limite superior de pontos de processo da pinça",
	"k192": "Tempo para determinar o fim do ponto da pinça (s)",
	"k193": "Número de pontos por peça",
	"k194": "Produção do turno",
	"k195": "Produção total",
	"k196": "Total de pontos de solda",
	"k197": "Valor atual",
	"k198": "Zerar",
	"k199": "Número de etapas de compensação",
	"k200": "Número de fresagens",
	"k201": "Pré-alarme de fresagem",
	"k202": "Pressão de subida da fresagem",
	"k203": "Pressão de descida da fresagem",
	"k204": "Etapa de compensação 1",
	"k205": "Etapa de compensação 2",
	"k206": "Etapa de compensação 3",
	"k207": "Etapa de compensação 4",
	"k208": "Etapa de compensação 5",
	"k209": "Etapa de compensação 6",
	"k210": "Etapa de compensação 7",
	"k211": "Etapa de compensação 8",
	"k212": "Etapa de compensação 9",
	"k213": "Nome da peça",
	"k214": "Erro ao carregar os dados da curva UIP",
	"k215": "Erro ao obter as configurações offline",
	"k216": "Erro ao obter as configurações do dispositivo",
	"k217": "Valor ajustado da produção do turno da pinça",
	"k218": "Valor ajustado",
	"k219": "Compensação de pressão (%)",
	"k220": "Selecione o intervalo de datas",
	"k221": "Data",
	"k222": "Tempo",
	"k223": "Descrição do alarme",
	"k224": "Registro",
	"k225": "Data de criação",
	"k226": "VIN da carroceria",
	"k227": "Solda 1 (kA/ms)",
	"k228": "Solda 2 (kA/ms)",
	"k229": "Solda 3 (kA/ms)",
	"k230": "Nº da pinça em uso",
	"k231": "Energia (kJ)",
	"k232": "Largura de pulso de saída (%)",
	"k233": "Tensão secundária (V)",
	"k234": "Resistência secundária (μΩ)",
	"k235": "Valor UIP",
	"k236": "Todos",
	"k237": "Sem alarme",
	"k238": "Com alarme",
	"k239": "Antes da alteração",
	"k240": "Após a alteração",
	"k241": "Código do ponto de solda",
	"k242": "Nº da linha",
	"k243": "Pressão (N)",
	"k244": "Espessura da chapa (mm)",
	"k245": "Modelo do veículo",
	"k246": "Informações do ponto de solda",
	"k247": "Material da chapa 1",
	"k248": "Espessura da chapa 1 (mm)",
	"k249": "Material da chapa 2",
	"k250": "Espessura da chapa 2 (mm)",
	"k251": "Material da chapa 3",
	"k252": "Espessura da chapa 3 (mm)",
	"k253": "Material da chapa 4",
	"k254": "Espessura da chapa 4 (mm)",
	"k255": "Ativar",
	"k256": "Resetar",
	"k257": "Conteúdo",
	"k258": "Código do modelo do veículo",
	"k259": "Nº de mapeamento do ponto de solda",
	"k260": "Erro ao consultar os parâmetros",
	"k261": "Dispositivo atual",
	"k262": "Eletrodo 1",
	"k263": "Eletrodo 2",
	"k264": "Biblioteca → dispositivo",
	"k265": "A biblioteca offline não está configurada; a sincronização não é permitida",
	"k266": "Falha na função de exportação",
	"k267": "Erro ao ler os dados do programa",
	"k268": "Chave primária",
	"k269": "Nome da peça",
	"k270": "Tempo de pré-pressão (ms)",
	"k271": "Tempo da pressão de acompanhamento (ms)",
	"k272": "Corrente de pré-soldagem (kA)",
	"k273": "Tempo de pré-soldagem (ms)",
	"k274": "Tempo de resfriamento 0 (ms)",
	"k275": "Tempo de rampa de subida (ms)",
	"k276": "Corrente da solda 1 (kA)",
	"k277": "Tempo da solda 1 (ms)",
	"k278": "Tempo de resfriamento 1 (ms)",
	"k279": "Corrente da solda 2 (kA)",
	"k280": "Tempo da solda 2 (ms)",
	"k281": "Tempo de resfriamento 2 (ms)",
	"k282": "Corrente da solda 3 (kA)",
	"k283": "Tempo da solda 3 (ms)",
	"k284": "Tempo de rampa de descida (ms)",
	"k285": "Tempo de resfriamento 3 (ms)",
	"k286": "Corrente de pós-soldagem (kA)",
	"k287": "Tempo de pós-soldagem (ms)",
	"k288": "Tempo de retenção (ms)",
	"k289": "Tempo de pausa (ms)",
	"k290": "Coeficiente de compensação escalonada",
	"k291": "Número de repetições",
	"k292": "Contagem atual de pontos",
	"k293": "Tensão do capacitor primário",
	"k294": "Status das entradas (In00–In31)",
	"k295": "Status das saídas 0 (Out00–Out31)",
	"k296": "Modo de trabalho atual do sistema",
	"k297": "Contagem de pontos por peça da pinça de solda 1",
	"k298": "Contagem de pontos por peça da pinça de solda 2",
	"k299": "Contagem da produção do turno da pinça de solda 1",
	"k300": "Contagem da produção do turno da pinça de solda 2",
	"k301": "Contagem total de produção da pinça de solda 1",
	"k302": "Contagem total de produção da pinça de solda 2",
	"k303": "Contagem total de pontos de solda da pinça de solda 1",
	"k304": "Contagem total de pontos de solda da pinça de solda 2",
	"k305": "Contagem atual das etapas de compensação da pinça de solda 1",
	"k306": "Contagem atual das etapas de compensação da pinça de solda 2",
	"k307": "Contagem atual de fresagens da pinça de solda 1",
	"k308": "Contagem atual de fresagens da pinça de solda 2",
	"k309": "Número do programa atual da pinça de solda 2",
	"k310": "Número de registros históricos de alarme",
	"k311": "Nº da pinça em uso",
	"k312": "Energia",
	"k313": "Capacidade de carga",
	"k314": "Tensão secundária",
	"k315": "Resistência secundária",
	"k316": "Indicador de alarme",
	"k317": "Número de níveis vinculados ao programa da partida 1",
	"k318": "Habilitar atraso da partida até após a pré-pressão",
	"k319": "Habilitar compensação escalonada",
	"k320": "Pressão de subida da fresagem da pinça A",
	"k321": "Habilitar função de ressoldagem",
	"k322": "Seleção da função de E/S",
	"k323": "Pressão de fresagem da pinça A",
	"k324": "Tempo para determinar o fim do ponto de solda da pinça",
	"k325": "Número de inversores",
	"k326": "Detecção do feedback de corrente",
	"k327": "Configuração da prioridade das funções de controle",
	"k328": "Valor ajustado do número de etapas de compensação",
	"k329": "Contagem atual das etapas de compensação",
	"k330": "Valor ajustado do número de fresagens",
	"k331": "Contagem atual de fresagens",
	"k332": "Valor ajustado de pontos para pré-alarme de fresagem",
	"k333": "Número de pontos da etapa de compensação 1",
	"k334": "Compensação de potência 1",
	"k335": "Compensação de pressão 1",
	"k336": "Número de pontos da etapa de compensação 2",
	"k337": "Compensação de potência 2",
	"k338": "Compensação de pressão 2",
	"k339": "Número de pontos da etapa de compensação 3",
	"k340": "Compensação de potência 3",
	"k341": "Compensação de pressão 3",
	"k342": "Número de pontos da etapa de compensação 4",
	"k343": "Compensação de potência 4",
	"k344": "Compensação de pressão 4",
	"k345": "Número de pontos da etapa de compensação 5",
	"k346": "Compensação de potência 5",
	"k347": "Compensação de pressão 5",
	"k348": "Número de pontos da etapa de compensação 6",
	"k349": "Compensação de potência 6",
	"k350": "Compensação de pressão 6",
	"k351": "Número de pontos da etapa de compensação 7",
	"k352": "Compensação de potência 7",
	"k353": "Compensação de pressão 7",
	"k354": "Número de pontos da etapa de compensação 8",
	"k355": "Compensação de potência 8",
	"k356": "Compensação de pressão 8",
	"k357": "Número de pontos da etapa de compensação 9",
	"k358": "Pressão de subida da fresagem",
	"k359": "Pressão de descida da fresagem",
	"k360": "Configuração das pinças",
	"k361": "Modo de configuração das pinças",
	"k362": "Uma pinça",
	"k363": "Duas pinças",
	"k364": "Múltiplas pinças",
	"k365": "Modo de grande abertura da pinça",
	"k366": "Mantido",
	"k367": "Momentâneo",
	"k368": "Estado do braço do eletrodo ao desligar",
	"k369": "Pequena abertura",
	"k370": "Grande abertura",
	"k371": "Tipo de válvula pneumática da grande abertura",
	"k372": "Solenoide simples",
	"k373": "Solenoide duplo",
	"k374": "Atraso de partida da pequena abertura",
	"k375": "Permitir soldagem com fluxo de água insuficiente",
	"k376": "Monitoramento do fluxo de água da pinça 2",
	"k377": "O usuário “{{.a}}” atualizou as configurações de aquisição de curvas do dispositivo ID “{{.b}}”",
	"k378": "O usuário “{{.a}}” enviou a biblioteca de programas DIP “{{.c}}” ao dispositivo “{{.b}}”",
	"k379": "X",
	"k380": "Y",
	"k381": "Z",
	"k382": "O número de mapeamento do ponto de solda já existe",
	"k383": "Ponto de solda criado com sucesso",
	"k384": "Falha ao criar o ponto de solda",
	"k385": "Ponto de solda editado com sucesso",
	"k386": "Falha ao editar o ponto de solda",
	"k387": "Falha ao salvar as informações adicionais do ponto de solda",
	"k388": "Falha ao consultar as informações adicionais do ponto de solda",
	"k389": "Falha no envio; o dispositivo {{.a}} pode estar offline",
	"k390": "O número de pontos é inválido ou superior a 2000",
	"k391": "O registro UIR ainda não foi iniciado",
	"k392": "O registro UIR já foi iniciado; não é necessário iniciá-lo novamente",
	"k393": "Iniciar registro UIR",
	"k394": "Parar registro UIR",
	"k395": "Erro ao consultar dados",
	"k396": "Curva selecionada",
	"k397": "Gerar curva de referência",
	"k398": "→ Controlador",
	"k399": "→ PC",
	"k400": "Pacote de curvas",
	"k401": "Carregado com sucesso",
	"k402": "Não há alarmes; não é necessário resetar",
	"k403": "Erro ao ler parâmetros do sistema",
	"k404": "O modo de limite de corrente do arquivo não corresponde ao dispositivo de destino",
	"w001": "Corrente da solda 1 acima do limite",
	"w002": "Corrente da solda 1 abaixo do limite",
	"w003": "Corrente da solda 2 acima do limite",
	"w004": "Corrente da solda 2 abaixo do limite",
	"w005": "Corrente da solda 3 acima do limite",
	"w006": "Corrente da solda 3 abaixo do limite",
	"w007": "Falha do IGBT",
	"w008": "Falha da parada de emergência",
	"w009": "Temperatura do transformador 1 acima do limite",
	"w010": "Temperatura do tiristor acima do limite",
	"w011": "Falha da chave de fluxo de água",
	"w012": "Falha do pressostato de ar",
	"w013": "Tempo limite da permissão de soldagem excedido",
	"w014": "Tempo limite da entrada programável 1 excedido",
	"w015": "Tempo limite da entrada programável 2 excedido",
	"w016": "Tempo limite da entrada programável 3 excedido",
	"w017": "Erro na tabela de parâmetros da memória",
	"w018": "Tempo limite de carga do capacitor primário excedido",
	"w019": "Pedal acionado incorretamente durante a energização do sistema",
	"w020": "Tensão do capacitor primário muito baixa",
	"w021": "Erro de gravação dos dados FRAM",
	"w022": "Erro na configuração do tempo de pré-pressão",
	"w023": "Falha de comunicação RS-485",
	"w024": "Pinça suspensa: alarme da chave de fluxo de água da pinça 2",
	"w025": "Proteção da cortina de luz",
	"w026": "Erro na configuração do tipo de transformador",
	"w027": "Erro na configuração do modo de corrente constante",
	"w028": "Erro na configuração da faixa de corrente secundária",
	"w029": "Alarme de soldagem inibida pela interface",
	"w030": "Proteção da saída de corrente",
	"w031": "Temperatura do transformador 2 acima do limite",
	"w032": "Erro no feedback de corrente",
	"w033": "A contagem atual de pontos da pinça 1 atingiu o valor definido por peça",
	"w034": "A contagem real de pontos da pinça 1 está acima do limite superior por peça",
	"w035": "A contagem real de pontos da pinça 1 está abaixo do limite inferior por peça",
	"w036": "A produção do turno da pinça 1 atingiu o valor definido",
	"w037": "Pré-alarme de fresagem da pinça 1",
	"w038": "Alarme de fresagem da pinça 1",
	"w039": "Alarme de troca do eletrodo da pinça 1",
	"w040": "Pré-alarme de troca do eletrodo da pinça 1",
	"w041": "Reservado 01",
	"w042": "A contagem atual de pontos da pinça 2 atingiu o valor definido por peça",
	"w043": "A contagem real de pontos da pinça 2 está acima do limite superior por peça",
	"w044": "A contagem real de pontos da pinça 2 está abaixo do limite inferior por peça",
	"w045": "A produção do turno da pinça 2 atingiu o valor definido",
	"w046": "Pré-alarme de fresagem da pinça 2",
	"w047": "Alarme de fresagem da pinça 2",
	"w048": "Alarme de troca do eletrodo da pinça 2",
	"w049": "Pré-alarme de troca do eletrodo da pinça 2",
	"w050": "Reservado 49",
	"w051": "Reservado 50",
	"w052": "Reservado 51",
	"w053": "Reservado 52",
	"w054": "Reservado 53",
	"w055": "Reservado 54",
	"w056": "Reservado 55",
	"w057": "Reservado 56",
	"w058": "Reservado 57",
	"w059": "Reservado 58",
	"w060": "Reservado 59",
	"w061": "Erro do RTC",
	"w062": "Erro de gravação no cartão SD",
	"w063": "Erro nos parâmetros de calibração",
	"w164": "Erro nos parâmetros de compensação escalonada",
	"w064": "Mau contato no cabo de feedback de corrente",
	"w065": "Alarme de resistência de soldagem alta",
	"w066": "Alarme de resistência de soldagem baixa",
	"w067": "Falha no cabo de tensão secundária",
	"w168": "UIP abaixo do limite",
	"w069": "UIP acima do limite",
	"w068": "Falha na soldagem adaptativa",
	"w097": "Alarme de expulsão de soldagem",
	"w098": "Largura de pulso de saída acima do limite",
	"w099": "UIP abaixo do limite",
	"w100": "UIP acima do limite",
	"z001": "{{.a}} (faixa permitida: “{{.b}}–{{.c}}{{.d}}”); valor de destino: “{{.e}}”",
	"z002": "Não é um número de ponto flutuante: {{.a}}",
	"z003": "Não é uma string: {{.a}}",
	"z004": "O comprimento esperado é {{.a}}, mas o comprimento atual é {{.b}}",
	"z005": "{{.a}}: este método não foi implementado no controlador",
	"z006": "Offline",
	"z007": "Online",
	"z008": "Anormal",
	"z009": "Excluído",
	"z010": "{{.a}}: entrada inválida",
	"z011": "Erro de validação da entrada",
	"z012": "Registros de alarmes",
	"z013": "Programa de diagnóstico",
	"z014": "Gerenciamento do banco de dados",
	"z015": "Histórico de alterações",
	"z016": "Gerenciamento da produção",
	"z017": "Parâmetros do programa",
	"z018": "Registros de soldagem",
	"z019": "Monitoramento em tempo real",
	"z020": "Parâmetros do sistema",
	"z021": "Não ativado",
	"z022": "Normal",
	"z023": "Bloqueado",
	"z024": "Excluído",
	"z025": "Administrador",
	"z026": "Operador",
	"z027": "Visualizador",
	"z028": "Nº do programa fora da faixa (0-959)",
	"z029": "Nº do programa fora da faixa (0-63)",
	"z030": "Controlador 1 não é um número inteiro válido",
	"z031": "Controlador 2 não é um número inteiro válido",
	"z032": "O número do programa 1 não é um inteiro válido",
	"z033": "O número do programa 2 não é um inteiro válido",
	"z034": "Não é permitido comparar o mesmo programa de soldagem",
	"z035": "Nome da peça",
	"z036": "Lote de produção",
	"z037": "Operador",
	"z038": "Erro ao consultar o programa offline",
	"z039": "Não é um número inteiro: {{.a}}",
	"z040": "Reconectando...",
	"g001": "Contagem total de pontos de solda da pinça de solda 3",
	"g002": "Contagem total de pontos de solda da pinça de solda 4",
	"g003": "Contagem total de pontos de solda da pinça de solda 5",
	"g004": "Valor ajustado do número de etapas de compensação da pinça de solda 3",
	"g005": "Valor ajustado do número de fresagens da pinça de solda 3",
	"g006": "Valor ajustado de pontos para pré-alarme de fresagem da pinça de solda 3",
	"g007": "Contagem atual das etapas de compensação da pinça de solda 3",
	"g008": "Contagem atual de fresagens da pinça de solda 3",
	"g009": "Valor ajustado do número de etapas de compensação da pinça de solda 4",
	"g010": "Valor ajustado do número de fresagens da pinça de solda 4",
	"g011": "Valor ajustado de pontos para pré-alarme de fresagem da pinça de solda 4",
	"g012": "Contagem atual das etapas de compensação da pinça de solda 4",
	"g013": "Contagem atual de fresagens da pinça de solda 4",
	"g014": "Valor ajustado do número de etapas de compensação da pinça de solda 5",
	"g015": "Valor ajustado do número de fresagens da pinça de solda 5",
	"g016": "Valor ajustado de pontos para pré-alarme de fresagem da pinça de solda 5",
	"g017": "Contagem atual das etapas de compensação da pinça de solda 5",
	"g018": "Contagem atual de fresagens da pinça de solda 5",
	"g019": "Número de pontos da etapa 1 da compensação escalonada da pinça de solda 3",
	"g020": "Compensação de potência da etapa 1 da pinça de solda 3",
	"g021": "Compensação de pressão da etapa 1 da pinça de solda 3",
	"g022": "Número de pontos da etapa 2 da compensação escalonada da pinça de solda 3",
	"g023": "Compensação de potência da etapa 2 da pinça de solda 3",
	"g024": "Compensação de pressão da etapa 2 da pinça de solda 3",
	"g025": "Número de pontos da etapa 3 da compensação escalonada da pinça de solda 3",
	"g026": "Compensação de potência da etapa 3 da pinça de solda 3",
	"g027": "Compensação de pressão da etapa 3 da pinça de solda 3",
	"g028": "Número de pontos da etapa 4 da compensação escalonada da pinça de solda 3",
	"g029": "Compensação de potência da etapa 4 da pinça de solda 3",
	"g030": "Compensação de pressão da etapa 4 da pinça de solda 3",
	"g031": "Número de pontos da etapa 5 da compensação escalonada da pinça de solda 3",
	"g032": "Compensação de potência da etapa 5 da pinça de solda 3",
	"g033": "Compensação de pressão da etapa 5 da pinça de solda 3",
	"g034": "Número de pontos da etapa 6 da compensação escalonada da pinça de solda 3",
	"g035": "Compensação de potência da etapa 6 da pinça de solda 3",
	"g036": "Compensação de pressão da etapa 6 da pinça de solda 3",
	"g037": "Número de pontos da etapa 7 da compensação escalonada da pinça de solda 3",
	"g038": "Compensação de potência da etapa 7 da pinça de solda 3",
	"g039": "Compensação de pressão da etapa 7 da pinça de solda 3",
	"g040": "Número de pontos da etapa 8 da compensação escalonada da pinça de solda 3",
	"g041": "Compensação de potência da etapa 8 da pinça de solda 3",
	"g042": "Compensação de pressão da etapa 8 da pinça de solda 3",
	"g043": "Número de pontos da etapa 9 da compensação escalonada da pinça de solda 3",
	"g044": "Compensação de potência da etapa 9 da pinça de solda 3",
	"g045": "Compensação de pressão da etapa 9 da pinça de solda 3",
	"g046": "Número de pontos da etapa 1 da compensação escalonada da pinça de solda 4",
	"g047": "Compensação de potência da etapa 1 da pinça de solda 4",
	"g048": "Compensação de pressão da etapa 1 da pinça de solda 4",
	"g049": "Número de pontos da etapa 2 da compensação escalonada da pinça de solda 4",
	"g050": "Compensação de potência da etapa 2 da pinça de solda 4",
	"g051": "Compensação de pressão da etapa 2 da pinça de solda 4",
	"g052": "Número de pontos da etapa 3 da compensação escalonada da pinça de solda 4",
	"g053": "Compensação de potência da etapa 3 da pinça de solda 4",
	"g054": "Compensação de pressão da etapa 3 da pinça de solda 4",
	"g055": "Número de pontos da etapa 4 da compensação escalonada da pinça de solda 4",
	"g056": "Compensação de potência da etapa 4 da pinça de solda 4",
	"g057": "Compensação de pressão da etapa 4 da pinça de solda 4",
	"g058": "Número de pontos da etapa 5 da compensação escalonada da pinça de solda 4",
	"g059": "Compensação de potência da etapa 5 da pinça de solda 4",
	"g060": "Compensação de pressão da etapa 5 da pinça de solda 4",
	"g061": "Número de pontos da etapa 6 da compensação escalonada da pinça de solda 4",
	"g062": "Compensação de potência da etapa 6 da pinça de solda 4",
	"g063": "Compensação de pressão da etapa 6 da pinça de solda 4",
	"g064": "Número de pontos da etapa 7 da compensação escalonada da pinça de solda 4",
	"g065": "Compensação de potência da etapa 7 da pinça de solda 4",
	"g066": "Compensação de pressão da etapa 7 da pinça de solda 4",
	"g067": "Número de pontos da etapa 8 da compensação escalonada da pinça de solda 4",
	"g068": "Compensação de potência da etapa 8 da pinça de solda 4",
	"g069": "Compensação de pressão da etapa 8 da pinça de solda 4",
	"g070": "Número de pontos da etapa 9 da compensação escalonada da pinça de solda 4",
	"g071": "Compensação de potência da etapa 9 da pinça de solda 4",
	"g072": "Compensação de pressão da etapa 9 da pinça de solda 4",
	"g073": "Número de pontos da etapa 1 da compensação escalonada da pinça de solda 5",
	"g074": "Compensação de potência da etapa 1 da pinça de solda 5",
	"g075": "Compensação de pressão da etapa 1 da pinça de solda 5",
	"g076": "Número de pontos da etapa 2 da compensação escalonada da pinça de solda 5",
	"g077": "Compensação de potência da etapa 2 da pinça de solda 5",
	"g078": "Compensação de pressão da etapa 2 da pinça de solda 5",
	"g079": "Número de pontos da etapa 3 da compensação escalonada da pinça de solda 5",
	"g080": "Compensação de potência da etapa 3 da pinça de solda 5",
	"g081": "Compensação de pressão da etapa 3 da pinça de solda 5",
	"g082": "Número de pontos da etapa 4 da compensação escalonada da pinça de solda 5",
	"g083": "Compensação de potência da etapa 4 da pinça de solda 5",
	"g084": "Compensação de pressão da etapa 4 da pinça de solda 5",
	"g085": "Número de pontos da etapa 5 da compensação escalonada da pinça de solda 5",
	"g086": "Compensação de potência da etapa 5 da pinça de solda 5",
	"g087": "Compensação de pressão da etapa 5 da pinça de solda 5",
	"g088": "Número de pontos da etapa 6 da compensação escalonada da pinça de solda 5",
	"g089": "Compensação de potência da etapa 6 da pinça de solda 5",
	"g090": "Compensação de pressão da etapa 6 da pinça de solda 5",
	"g091": "Número de pontos da etapa 7 da compensação escalonada da pinça de solda 5",
	"g092": "Compensação de potência da etapa 7 da pinça de solda 5",
	"g093": "Compensação de pressão da etapa 7 da pinça de solda 5",
	"g094": "Número de pontos da etapa 8 da compensação escalonada da pinça de solda 5",
	"g095": "Compensação de potência da etapa 8 da pinça de solda 5",
	"g096": "Compensação de pressão da etapa 8 da pinça de solda 5",
	"g097": "Número de pontos da etapa 9 da compensação escalonada da pinça de solda 5",
	"g098": "Compensação de potência da etapa 9 da pinça de solda 5",
	"g099": "Compensação de pressão da etapa 9 da pinça de solda 5",
	"g100": "Parâmetro de ajuste fino da corrente constante no secundário da pinça de solda 3",
	"g101": "Parâmetro de ajuste fino da corrente constante no primário da pinça de solda 4",
	"g102": "Parâmetro de ajuste fino da corrente constante no secundário da pinça de solda 4",
	"g103": "Parâmetro de ajuste fino da corrente constante no primário da pinça de solda 5",
	"g104": "Parâmetro de ajuste fino da corrente constante no secundário da pinça de solda 5",
	"g105": "Valor PWM mínimo ajustado da corrente primária da pinça de solda 3",
	"g106": "Valor PWM ajustado no ponto 1 da corrente primária da pinça de solda 3",
	"g107": "Valor PWM ajustado no ponto 2 da corrente primária da pinça de solda 3",
	"g108": "Valor PWM ajustado no ponto 3 da corrente primária da pinça de solda 3",
	"g109": "Valor PWM ajustado no ponto 4 da corrente primária da pinça de solda 3",
	"g110": "Valor PWM ajustado no ponto 5 da corrente primária da pinça de solda 3",
	"g111": "Valor PWM ajustado no ponto 6 da corrente primária da pinça de solda 3",
	"g112": "Valor PWM máximo ajustado da corrente primária da pinça de solda 3",
	"g113": "Valor amostrado mínimo da corrente primária da pinça de solda 3",
	"g114": "Valor amostrado no ponto 1 da corrente primária da pinça de solda 3",
	"g115": "Valor amostrado no ponto 2 da corrente primária da pinça de solda 3",
	"g116": "Valor amostrado no ponto 3 da corrente primária da pinça de solda 3",
	"g117": "Valor amostrado no ponto 4 da corrente primária da pinça de solda 3",
	"g118": "Valor amostrado no ponto 5 da corrente primária da pinça de solda 3",
	"g119": "Valor amostrado no ponto 6 da corrente primária da pinça de solda 3",
	"g120": "Valor amostrado máximo da corrente primária da pinça de solda 3",
	"g121": "Valor exibido mínimo da corrente primária da pinça de solda 3",
	"g122": "Valor exibido no ponto 1 da corrente primária da pinça de solda 3",
	"g123": "Valor exibido no ponto 2 da corrente primária da pinça de solda 3",
	"g124": "Valor exibido no ponto 3 da corrente primária da pinça de solda 3",
	"g125": "Valor exibido no ponto 4 da corrente primária da pinça de solda 3",
	"g126": "Valor exibido no ponto 5 da corrente primária da pinça de solda 3",
	"g127": "Valor exibido no ponto 6 da corrente primária da pinça de solda 3",
	"g128": "Valor exibido máximo da corrente primária da pinça de solda 3",
	"g129": "Valor PWM mínimo ajustado da corrente secundária da pinça de solda 3",
	"g130": "Valor PWM ajustado no ponto 1 da corrente secundária da pinça de solda 3",
	"g131": "Valor PWM ajustado no ponto 2 da corrente secundária da pinça de solda 3",
	"g132": "Valor PWM ajustado no ponto 3 da corrente secundária da pinça de solda 3",
	"g133": "Valor PWM ajustado no ponto 4 da corrente secundária da pinça de solda 3",
	"g134": "Valor PWM ajustado no ponto 5 da corrente secundária da pinça de solda 3",
	"g135": "Valor PWM ajustado no ponto 6 da corrente secundária da pinça de solda 3",
	"g136": "Valor PWM máximo ajustado da corrente secundária da pinça de solda 3",
	"g137": "Valor amostrado mínimo da corrente secundária da pinça de solda 3",
	"g138": "Valor amostrado no ponto 1 da corrente secundária da pinça de solda 3",
	"g139": "Valor amostrado no ponto 2 da corrente secundária da pinça de solda 3",
	"g140": "Valor amostrado no ponto 3 da corrente secundária da pinça de solda 3",
	"g141": "Valor amostrado no ponto 4 da corrente secundária da pinça de solda 3",
	"g142": "Valor amostrado no ponto 5 da corrente secundária da pinça de solda 3",
	"g143": "Valor amostrado no ponto 6 da corrente secundária da pinça de solda 3",
	"g144": "Valor amostrado máximo da corrente secundária da pinça de solda 3",
	"g145": "Valor exibido mínimo da corrente secundária da pinça de solda 3",
	"g146": "Valor exibido no ponto 1 da corrente secundária da pinça de solda 3",
	"g147": "Valor exibido no ponto 2 da corrente secundária da pinça de solda 3",
	"g148": "Valor exibido no ponto 3 da corrente secundária da pinça de solda 3",
	"g149": "Valor exibido no ponto 4 da corrente secundária da pinça de solda 3",
	"g150": "Valor exibido no ponto 5 da corrente secundária da pinça de solda 3",
	"g151": "Valor exibido no ponto 6 da corrente secundária da pinça de solda 3",
	"g152": "Valor exibido máximo da corrente secundária da pinça de solda 3",
	"g153": "Valor PWM mínimo ajustado da corrente primária da pinça de solda 4",
	"g154": "Valor PWM ajustado no ponto 1 da corrente primária da pinça de solda 4",
	"g155": "Valor PWM ajustado no ponto 2 da corrente primária da pinça de solda 4",
	"g156": "Valor PWM ajustado no ponto 3 da corrente primária da pinça de solda 4",
	"g157": "Valor PWM ajustado no ponto 4 da corrente primária da pinça de solda 4",
	"g158": "Valor PWM ajustado no ponto 5 da corrente primária da pinça de solda 4",
	"g159": "Valor PWM ajustado no ponto 6 da corrente primária da pinça de solda 4",
	"g160": "Valor PWM máximo ajustado da corrente primária da pinça de solda 4",
	"g161": "Valor amostrado mínimo da corrente primária da pinça de solda 4",
	"g162": "Valor amostrado no ponto 1 da corrente primária da pinça de solda 4",
	"g163": "Valor amostrado no ponto 2 da corrente primária da pinça de solda 4",
	"g164": "Valor amostrado no ponto 3 da corrente primária da pinça de solda 4",
	"g165": "Valor amostrado no ponto 4 da corrente primária da pinça de solda 4",
	"g166": "Valor amostrado no ponto 5 da corrente primária da pinça de solda 4",
	"g167": "Valor amostrado no ponto 6 da corrente primária da pinça de solda 4",
	"g168": "Valor amostrado máximo da corrente primária da pinça de solda 4",
	"g169": "Valor exibido mínimo da corrente primária da pinça de solda 4",
	"g170": "Valor exibido no ponto 1 da corrente primária da pinça de solda 4",
	"g171": "Valor exibido no ponto 2 da corrente primária da pinça de solda 4",
	"g172": "Valor exibido no ponto 3 da corrente primária da pinça de solda 4",
	"g173": "Valor exibido no ponto 4 da corrente primária da pinça de solda 4",
	"g174": "Valor exibido no ponto 5 da corrente primária da pinça de solda 4",
	"g175": "Valor exibido no ponto 6 da corrente primária da pinça de solda 4",
	"g176": "Valor exibido máximo da corrente primária da pinça de solda 4",
	"g177": "Valor PWM mínimo ajustado da corrente secundária da pinça de solda 4",
	"g178": "Valor PWM ajustado no ponto 1 da corrente secundária da pinça de solda 4",
	"g179": "Valor PWM ajustado no ponto 2 da corrente secundária da pinça de solda 4",
	"g180": "Valor PWM ajustado no ponto 3 da corrente secundária da pinça de solda 4",
	"g181": "Valor PWM ajustado no ponto 4 da corrente secundária da pinça de solda 4",
	"g182": "Valor PWM ajustado no ponto 5 da corrente secundária da pinça de solda 4",
	"g183": "Valor PWM ajustado no ponto 6 da corrente secundária da pinça de solda 4",
	"g184": "Valor PWM máximo ajustado da corrente secundária da pinça de solda 4",
	"g185": "Valor amostrado mínimo da corrente secundária da pinça de solda 4",
	"g186": "Valor amostrado no ponto 1 da corrente secundária da pinça de solda 4",
	"g187": "Valor amostrado no ponto 2 da corrente secundária da pinça de solda 4",
	"g188": "Valor amostrado no ponto 3 da corrente secundária da pinça de solda 4",
	"g189": "Valor amostrado no ponto 4 da corrente secundária da pinça de solda 4",
	"g190": "Valor amostrado no ponto 5 da corrente secundária da pinça de solda 4",
	"g191": "Valor amostrado no ponto 6 da corrente secundária da pinça de solda 4",
	"g192": "Valor amostrado máximo da corrente secundária da pinça de solda 4",
	"g193": "Valor exibido mínimo da corrente secundária da pinça de solda 4",
	"g194": "Valor exibido no ponto 1 da corrente secundária da pinça de solda 4",
	"g195": "Valor exibido no ponto 2 da corrente secundária da pinça de solda 4",
	"g196": "Valor exibido no ponto 3 da corrente secundária da pinça de solda 4",
	"g197": "Valor exibido no ponto 4 da corrente secundária da pinça de solda 4",
	"g198": "Valor exibido no ponto 5 da corrente secundária da pinça de solda 4",
	"g199": "Valor exibido no ponto 6 da corrente secundária da pinça de solda 4",
	"g200": "Valor exibido máximo da corrente secundária da pinça de solda 4",
	"g201": "Valor PWM mínimo ajustado da corrente primária da pinça de solda 5",
	"g202": "Valor PWM ajustado no ponto 1 da corrente primária da pinça de solda 5",
	"g203": "Valor PWM ajustado no ponto 2 da corrente primária da pinça de solda 5",
	"g204": "Valor PWM ajustado no ponto 3 da corrente primária da pinça de solda 5",
	"g205": "Valor PWM ajustado no ponto 4 da corrente primária da pinça de solda 5",
	"g206": "Valor PWM ajustado no ponto 5 da corrente primária da pinça de solda 5",
	"g207": "Valor PWM ajustado no ponto 6 da corrente primária da pinça de solda 5",
	"g208": "Valor PWM máximo ajustado da corrente primária da pinça de solda 5",
	"g209": "Valor amostrado mínimo da corrente primária da pinça de solda 5",
	"g210": "Valor amostrado no ponto 1 da corrente primária da pinça de solda 5",
	"g211": "Valor amostrado no ponto 2 da corrente primária da pinça de solda 5",
	"g212": "Valor amostrado no ponto 3 da corrente primária da pinça de solda 5",
	"g213": "Valor amostrado no ponto 4 da corrente primária da pinça de solda 5",
	"g214": "Valor amostrado no ponto 5 da corrente primária da pinça de solda 5",
	"g215": "Valor amostrado no ponto 6 da corrente primária da pinça de solda 5",
	"g216": "Valor amostrado máximo da corrente primária da pinça de solda 5",
	"g217": "Valor exibido mínimo da corrente primária da pinça de solda 5",
	"g218": "Valor exibido no ponto 1 da corrente primária da pinça de solda 5",
	"g219": "Valor exibido no ponto 2 da corrente primária da pinça de solda 5",
	"g220": "Valor exibido no ponto 3 da corrente primária da pinça de solda 5",
	"g221": "Valor exibido no ponto 4 da corrente primária da pinça de solda 5",
	"g222": "Valor exibido no ponto 5 da corrente primária da pinça de solda 5",
	"g223": "Valor exibido no ponto 6 da corrente primária da pinça de solda 5",
	"g224": "Valor exibido máximo da corrente primária da pinça de solda 5",
	"g225": "Valor PWM mínimo ajustado da corrente secundária da pinça de solda 5",
	"g226": "Valor PWM ajustado no ponto 1 da corrente secundária da pinça de solda 5",
	"g227": "Valor PWM ajustado no ponto 2 da corrente secundária da pinça de solda 5",
	"g228": "Valor PWM ajustado no ponto 3 da corrente secundária da pinça de solda 5",
	"g229": "Valor PWM ajustado no ponto 4 da corrente secundária da pinça de solda 5",
	"g230": "Valor PWM ajustado no ponto 5 da corrente secundária da pinça de solda 5",
	"g231": "Valor PWM ajustado no ponto 6 da corrente secundária da pinça de solda 5",
	"g232": "Valor PWM máximo ajustado da corrente secundária da pinça de solda 5",
	"g233": "Valor amostrado mínimo da corrente secundária da pinça de solda 5",
	"g234": "Valor amostrado no ponto 1 da corrente secundária da pinça de solda 5",
	"g235": "Valor amostrado no ponto 2 da corrente secundária da pinça de solda 5",
	"g236": "Valor amostrado no ponto 3 da corrente secundária da pinça de solda 5",
	"g237": "Valor amostrado no ponto 4 da corrente secundária da pinça de solda 5",
	"g238": "Valor amostrado no ponto 5 da corrente secundária da pinça de solda 5",
	"g239": "Valor amostrado no ponto 6 da corrente secundária da pinça de solda 5",
	"g240": "Valor amostrado máximo da corrente secundária da pinça de solda 5",
	"g241": "Valor exibido mínimo da corrente secundária da pinça de solda 5",
	"g242": "Valor exibido no ponto 1 da corrente secundária da pinça de solda 5",
	"g243": "Valor exibido no ponto 2 da corrente secundária da pinça de solda 5",
	"g244": "Valor exibido no ponto 3 da corrente secundária da pinça de solda 5",
	"g245": "Valor exibido no ponto 4 da corrente secundária da pinça de solda 5",
	"g246": "Valor exibido no ponto 5 da corrente secundária da pinça de solda 5",
	"g247": "Valor exibido no ponto 6 da corrente secundária da pinça de solda 5",
	"g248": "Valor exibido máximo da corrente secundária da pinça de solda 5",
	"g249": "Parâmetro de ajuste fino da corrente constante no primário da pinça de solda 3",
	"g250": "Tipo não definido: {{.a}}",
	"g251": "Valor ajustado da saída de pressão do eletrodo, ponto 1, pinça de solda 3",
	"g252": "Valor ajustado da saída de pressão do eletrodo, ponto 2, pinça de solda 3",
	"g253": "Valor medido/exibido da pressão do eletrodo, ponto 1, pinça de solda 3",
	"g254": "Valor medido/exibido da pressão do eletrodo, ponto 2, pinça de solda 3",
	"g255": "Valor ajustado da saída de pressão do eletrodo, ponto 1, pinça de solda 4",
	"g256": "Valor ajustado da saída de pressão do eletrodo, ponto 2, pinça de solda 4",
	"g257": "Valor medido/exibido da pressão do eletrodo, ponto 1, pinça de solda 4",
	"g258": "Valor medido/exibido da pressão do eletrodo, ponto 2, pinça de solda 4",
	"g259": "Valor ajustado da saída de pressão do eletrodo, ponto 1, pinça de solda 5",
	"g260": "Valor ajustado da saída de pressão do eletrodo, ponto 2, pinça de solda 5",
	"g261": "Valor medido/exibido da pressão do eletrodo, ponto 1, pinça de solda 5",
	"g262": "Valor medido/exibido da pressão do eletrodo, ponto 2, pinça de solda 5",
	"d001": "Atualizar quantidade",
	"d002": "O nº de mapeamento do ponto de solda é obrigatório e deve ser um número inteiro",
	"d003": "O nº do programa é obrigatório e deve ser um número inteiro",
	"d004": "A pressão é obrigatória e deve ser um número inteiro",
	"d005": "A espessura da chapa é obrigatória e deve ser decimal (faixa: 0–99999,99)",
	"d006": "X é obrigatório e deve ser decimal (faixa: 0–999999,9999999999)",
	"d007": "Y é obrigatório e deve ser decimal (faixa: 0–999999,9999999999)",
	"d008": "Z é obrigatório e deve ser decimal (faixa: 0–999999,9999999999)",
	"d009": "A espessura da chapa 1 deve ser decimal (faixa: 0–99999,99)",
	"d010": "A espessura da chapa 2 deve ser decimal (faixa: 0–99999,99)",
	"d011": "A espessura da chapa 3 deve ser decimal (faixa: 0–99999,99)",
	"d012": "A espessura da chapa 4 deve ser decimal (faixa: 0–99999,99)",
	"d013": "Os dados não poderão ser recuperados após a limpeza. Deseja continuar?",
	"d014": "Registro de parâmetros do sistema",
	"d015": "Registro de gerenciamento de pontos de solda",
	"d016": "Tipo de operação",
	"d017": "Adicionar",
	"d018": "Alterar",
	"d019": "Comparação de parâmetros",
	"d020": "O operador não existe; não é possível consultar",
	"d021": "O valor configurado está ausente ou é inválido",
	"d022": "Quantidade importada",
	"d023": "Calculando quantidade",
	"d024": "Quantidade validada",
	"d025": "Quantidade limpa",
	"d026": "Quantidade enviada",
	"d027": "Dados limpos com sucesso",
	"d028": "Falha ao limpar os dados",
	"d029": "Atualização dos pontos de solda",
	"d030": "Deseja atualizar os pontos de solda dos dispositivos selecionados?",
	"d031": "Ocorreu um erro na atualização dos pontos; não é possível operar",
	"d032": "Atualização dos pontos cancelada",
	"d033": "O dispositivo está offline; não é possível realizar esta operação.",
	"d034": "Pontos de solda atualizados com sucesso",
	"d035": "Visão geral da atualização dos pontos",
	"d036": "Detalhes da atualização dos pontos",
	"d037": "Progresso da atualização dos pontos",
	"d038": "Atualizando pontos de solda",
	"d039": "Falha na atualização dos pontos de solda",
	"d040": "Ao cancelar a atualização dos pontos, as operações restantes serão interrompidas. Deseja continuar?",
	"d041": "A tarefa de atualização dos pontos foi reiniciada.",
	"e001": "Estatísticas de expulsões",
	"e002": "Visualizar estatísticas de expulsões",
	"e003": "Gerenciar estatísticas de expulsões",
	"e004": "Dimensão da consulta",
	"e005": "Ponto de solda",
	"e006": "Erro na dimensão da consulta",
	"e007": "Contagem de expulsões",
	"e008": "Contagem de pontos de solda",
	"e009": "Contagem total",
	"e010": "Taxa de aprovação sem expulsões",
	"e011": "Visualização de dados",
	"e012": "Erro ao obter os dados dos modelos de veículo",
	"e013": "Filtro de pontos; separe vários valores por vírgula",
	"e014": "Filtro de programas; separe vários valores por vírgula",
	"e015": "Clique para copiar",
	"e016": "Nº de sequência",
	"e017": "<p>1. Consulte a taxa de expulsão selecionando uma dimensão e, em seguida, clique em \"Consultar\".</p><p>2. Depois de selecionar área/dispositivo/modelo do veículo/ponto/programa, selecione também os itens desejados na lista à esquerda.</p><p>3. Para filtrar pontos ou programas específicos, informe-os no campo de pesquisa; separe vários valores por vírgula.</p>",
	"e018": "Fábrica",
	"e019": "Registros de expulsões",
	"e020": "Limpar consulta",
	"e021": "Exportação concluída",
	"e022": "Iniciar exportação dos programas",
	"e023": "Exportando programas",
	"e024": "Iniciar sincronização",
	"e025": "Sincronizando",
	"e026": "Iniciar importação dos programas",
	"e027": "Importando programas",
	"e028": "Erro ao gravar programa de soldagem",
	"e029": "Nº inicial do programa",
	"e030": "Nº final do programa",
	"e031": "Converter VIN da carroceria em número sequencial",
	"e032": "Informe o intervalo de VIN da carroceria",
	"e033": "O VIN da carroceria deve ser um número inteiro",
	"e034": "O valor UIP deve ser um número inteiro maior que 0",
	"e035": "<p>É possível usar um filtro inverso no conteúdo do alarme. Por exemplo, \"!Corrente da solda 1 acima do limite\" exclui os registros que contêm \"Corrente da solda 1 acima do limite\".</p>",
	"e036": "Incluir curvas",
	"e037": "Gravando",
	"e038": "Registro não iniciado",
	"e039": "Pré-soldagem (kA/ms)",
	"e040": "Pós-soldagem (kA/ms)",
	"e041": "Dados da curva",
	"e042": "Visualização de curvas históricas",
	"e043": "O arquivo enviado não contém registros de soldagem",
	"e044": "Registros carregados com sucesso",
	"e045": "Valor ajustado da corrente de pré-soldagem",
	"e046": "Valor ajustado da corrente da solda 1",
	"e047": "Valor ajustado da corrente da solda 2",
	"e048": "Valor ajustado da corrente da solda 3",
	"e049": "Valor ajustado da corrente de pós-soldagem",
	"e050": "Valor mínimo ajustado da corrente da solda 1",
	"e051": "Valor máximo ajustado da corrente da solda 1",
	"e052": "Valor mínimo ajustado da corrente da solda 2",
	"e053": "Valor máximo ajustado da corrente da solda 2",
	"e054": "Valor mínimo ajustado da corrente da solda 3",
	"e055": "Valor máximo ajustado da corrente da solda 3",
	"e056": "Valor ajustado do número de pulsos da solda 2",
	"e057": "Exportar curvas",
	"e058": "Opções de exportação",
	"e059": "Selecione o arquivo a exportar dos registros de soldagem",
	"e060": "O registro atual não contém curva",
	"e061": "Erro ao enviar os parâmetros",
	"e062": "Erro do serviço",
	"e063": "Erro ao gravar os parâmetros de comunicação",
	"e064": "Excluir em lote",
	"e065": "Selecione os pontos de solda a excluir",
	"e066": "Salvar como imagem",
	"a001": "Manual",
	"a002": "Autônomo",
	"a003": "Tempo de ciclo",
	"a004": "s",
	"a005": "Pré-pressão",
	"a006": "Pressurização",
	"a007": "Sopro de ar",
	"a008": "Soldagem",
	"a009": "Nº do programa atual",
	"a010": "Nº do programa ajustado",
	"a011": "Descrição do programa",
	"a012": "Total de peças",
	"a013": "Produção",
	"a014": "Corrente de soldagem",
	"a015": "Vida útil do eletrodo",
	"a016": "Pressão de soldagem",
	"a017": "Limite de fusão",
	"a018": "Pontos de solda restantes",
	"a019": "Máximo",
	"a020": "Mínimo",
	"a021": "Deslocamento antes da soldagem",
	"a022": "Deslocamento após a soldagem",
	"a023": "Parada de emergência (NF)",
	"a024": "Alarme da pressão de entrada de ar (NF)",
	"a025": "Alarme do chiller",
	"a026": "Alarme de fluxo de água (NF)",
	"a027": "Chave de intertravamento da porta",
	"a028": "Alarme da temperatura da água",
	"a029": "Cortina de luz de segurança",
	"a030": "Parada de emergência remota",
	"a031": "Feedback do contator de potência",
	"a032": "Zerar contagem de pontos da peça",
	"a033": "Feedback da válvula de segurança",
	"a034": "Reset de ponto não soldado",
	"a035": "Manual/Automático",
	"a036": "Autônomo/Online",
	"a037": "Verificação/Soldagem energizada",
	"a038": "Comando bimanual 2",
	"a039": "Comando bimanual 1",
	"a040": "Partida por pedal",
	"a041": "Partida com uma mão",
	"a042": "Eletrodo móvel 2 na posição inicial",
	"a043": "Eletrodo móvel 1 na posição inicial",
	"a044": "Eletrodo móvel 2 na posição final",
	"a045": "Eletrodo móvel 1 na posição final",
	"a046": "Pino de localização do eletrodo fixo 2 avançado",
	"a047": "Pino de localização do eletrodo fixo 1 avançado",
	"a048": "Pino de localização do eletrodo fixo 2 recuado",
	"a049": "Pino de localização do eletrodo fixo 1 recuado",
	"a050": "Alimentador 1: alimentação concluída",
	"a051": "Alimentador 1: alarme geral",
	"a052": "Alimentador 1: haste na posição inicial",
	"a053": "Alimentador 1: alarme de falta de material",
	"a054": "Alimentador 1: haste na posição final",
	"a055": "Alimentador 1: alarme do cilindro de elevação na posição inicial",
	"a056": "Alimentador 1: alarme do cilindro de elevação na posição final",
	"a057": "Alimentador 2: alimentação concluída",
	"a058": "Alimentador 2: alarme geral",
	"a059": "Alimentador 2: haste na posição inicial",
	"a060": "Alimentador 2: alarme de falta de material",
	"a061": "Alimentador 2: haste na posição final",
	"a062": "Alimentador 2: alarme do cilindro de elevação na posição inicial",
	"a063": "Alimentador 2: alarme do cilindro de elevação na posição final",
	"a064": "Alimentador 3: alimentação concluída",
	"a065": "Alimentador 3: alarme geral",
	"a066": "Alimentador 3: haste na posição inicial",
	"a067": "Alimentador 3: alarme de falta de material",
	"a068": "Alimentador 3: haste na posição final",
	"a069": "Alimentador 3: alarme do cilindro de elevação na posição inicial",
	"a070": "Alimentador 3: alarme do cilindro de elevação na posição final",
	"a071": "Alimentador 4: alimentação concluída",
	"a072": "Alimentador 4: alarme geral",
	"a073": "Alimentador 4: haste na posição inicial",
	"a074": "Alimentador 4: alarme de falta de material",
	"a075": "Alimentador 4: haste na posição final",
	"a076": "Alimentador 4: alarme do cilindro de elevação na posição inicial",
	"a077": "Alimentador 4: alarme do cilindro de elevação na posição final",
	"a078": "Válvula geral de saída de água",
	"a079": "Buzina da torre sinalizadora",
	"a080": "Válvula geral de entrada de água",
	"a081": "Torre sinalizadora (verde)",
	"a082": "Válvula de multiplicação de força do eletrodo móvel 1",
	"a083": "Torre sinalizadora (amarela)",
	"a084": "Válvula de multiplicação de força do eletrodo móvel 2",
	"a085": "Torre sinalizadora (vermelha)",
	"a086": "Válvula de sopro do eletrodo fixo 1",
	"a087": "Válvula de pressurização do eletrodo móvel 1",
	"a088": "Válvula de curso auxiliar do eletrodo móvel 1 (solenoide simples)",
	"a089": "Válvula de pré-pressão do eletrodo móvel 1 (solenoide simples)",
	"a090": "Válvula de curso auxiliar do eletrodo móvel 1 — pequena abertura (solenoide duplo)",
	"a091": "Subida do eletrodo móvel 1 (solenoide duplo)",
	"a092": "Válvula de curso auxiliar do eletrodo móvel 1 — grande abertura (solenoide duplo)",
	"a093": "Descida do eletrodo móvel 1 (solenoide duplo)",
	"a094": "Válvula de sopro do eletrodo fixo 2",
	"a095": "Válvula de pressurização do eletrodo móvel 2",
	"a096": "Válvula de curso auxiliar do eletrodo móvel 2 (solenoide simples)",
	"a097": "Válvula de pré-pressão do eletrodo móvel 2 (solenoide simples)",
	"a098": "Válvula de curso auxiliar do eletrodo móvel 2 — pequena abertura (solenoide duplo)",
	"a099": "Subida do eletrodo móvel 2 (solenoide duplo)",
	"a100": "Válvula de curso auxiliar do eletrodo móvel 2 — grande abertura (solenoide duplo)",
	"a101": "Descida do eletrodo móvel 2 (solenoide duplo)",
	"a102": "Alimentador 1 retornar à posição inicial",
	"a103": "Alimentador 1 iniciar",
	"a104": "Alimentador 2 retornar à posição inicial",
	"a105": "Alimentador 2 iniciar",
	"a106": "Alimentador 3 retornar à posição inicial",
	"a107": "Alimentador 3 iniciar",
	"a108": "Alimentador 4 retornar à posição inicial",
	"a109": "Alimentador 4 iniciar",
	"a110": "Válvula do pino de localização do eletrodo fixo 1",
	"a111": "Válvula do pino de localização do eletrodo fixo 2",
	"a112": "Comando do chiller",
	"a113": "Solicitação de descarga",
	"a114": "Segurança",
	"a115": "Configuração de hardware",
	"a116": "Configuração de funções",
	"a117": "Configuração de comunicação",
	"a118": "Calibração",
	"a119": "Informações do sistema",
	"a120": "Porta do painel",
	"a121": "Pressão do ar de alimentação",
	"a122": "Cortina de luz",
	"a123": "Fluxo de água",
	"a124": "Buzina",
	"a125": "Torre sinalizadora",
	"a126": "Botões/chaves",
	"a127": "Pedal",
	"a128": "Uma mão",
	"a129": "Bimanual",
	"a130": "Circuito pneumático",
	"a131": "Válvula solenoide de entrada de ar",
	"a132": "Válvula proporcional",
	"a133": "Válvula de pré-pressão",
	"a134": "Válvula solenoide de pressurização",
	"a135": "Válvula solenoide de sopro",
	"a136": "Válvula solenoide de curso",
	"a137": "Válvula solenoide de multiplicação de força",
	"a138": "Válvula proporcional compartilhada para pré-pressão e pressurização",
	"a139": "Válvulas proporcionais independentes para pré-pressão e pressurização",
	"a140": "Pré-pressão com regulagem manual + válvula proporcional de pressurização",
	"a141": "Sem alterações",
	"a142": "Circuito de água",
	"a143": "Válvula solenoide de entrada de água",
	"a144": "Válvula solenoide de saída de água",
	"a145": "Chiller",
	"a146": "Chave de posição",
	"a147": "Eletrodo móvel na posição inicial",
	"a148": "Eletrodo móvel na posição final",
	"a149": "Pino de localização avançado",
	"a150": "Pino de localização recuado",
	"a151": "Sensor",
	"a152": "Deslocamento por encoder",
	"a153": "Deslocamento a laser",
	"a154": "Detecção da temperatura da água",
	"a155": "Pressão do eletrodo",
	"a156": "Não instalado",
	"a157": "Sensor de pressão de ar",
	"a158": "Célula de carga",
	"a159": "Nenhuma configuração foi alterada; não há nada para salvar.",
	"a160": "Alimentador",
	"a161": "Alimentador 1",
	"a162": "Alimentador 2",
	"a163": "Material alimentado",
	"a164": "Modo de alimentação",
	"a165": "Direção de alimentação",
	"a166": "Controlador",
	"a167": "Tipo",
	"a168": "Interface",
	"a169": "Retorno automático após atingir a posição final",
	"a170": "Manter na posição final",
	"a171": "Alimentar para o eletrodo fixo",
	"a172": "Alimentar para o eletrodo móvel",
	"a173": "Porca",
	"a174": "Parafuso",
	"a175": "Comunicação",
	"a176": "Comunicação (dados em tempo real) + E/S (partida/parada, reset, status essenciais, nº do programa etc.)",
	"a177": "Pino de localização",
	"a178": "Eletrodo móvel",
	"a179": "Válvula solenoide",
	"a180": "Taxa de transmissão",
	"a181": "Endereço do HRC-803",
	"a182": "Máscara de sub-rede",
	"a183": "Gateway",
	"a184": "Interface de sinais",
	"a185": "Modo de partida na operação autônoma",
	"a186": "Sinal de partida cancelável",
	"a187": "Tipo de sinal de fim do ciclo de soldagem",
	"a188": "Zerar automaticamente ao atingir a contagem de pontos da peça",
	"a189": "Pressão",
	"a190": "Unidade de pressão",
	"a191": "Limite para ativar a multiplicação de força",
	"a192": "Tempo",
	"a193": "Intervalo do modo contínuo",
	"a194": "Tempo para desligamento automático do chiller",
	"a195": "Partida bimanual",
	"a196": "Data de compilação",
	"a197": "Versão da interface",
	"a198": "Todos",
	"a199": "Fresagem ou Verificação",
	"a200": "Dispositivo: {{.a}} conectado com sucesso",
	"a201": "Dispositivo: {{.a}} desconectado com sucesso",
	"a202": "Conectar/Desconectar",
	"a203": "Habilitar envio de dados de soldagem"
}